import React, { Component } from "react"
import "./OperadoresNavieros.css";

import { Crud_Catalogos, Crud_error } from "../../herramientas/Crud_Catalogos";
import {
  Form,
  Icon,
  Button,
  List,
  Grid,
} from "tabler-react";
import { NotificationManager} from 'react-notifications';
import { DateRange } from "react-date-range";
import BaseSelect from "react-select";
import Select from "react-select";
import { es, id } from "date-fns/locale";
import { ListGroupItem } from "react-bootstrap";
import ModalLay from "../../components/ModalLay/ModalLay";
import Map from "../../components/maps/Map"
import { PersonasForm } from "../../Catalogos";
import PatiosForm from "../Patios/Formularios/PatiosForm";
import TractosForm from "../Tractos/TractosForm";
import RemolquesForm from "../Remolques/RemolquesForm";
import FixRequiredSelect from "../../components/validations/FixRequiredSelect"
import { forEach } from "jszip";
import { South } from "@mui/icons-material";

const Input = (props) => <Form.Input {...props} isHidden={false} />;
var prueba = JSON.parse(sessionStorage.getItem("usuario"))?.username.includes('maersk');
class OperadoresNavieros extends Component {

 
  
    constructor(props) {
      super(props);


     // const [isClearable, setIsClearable] = useState(true);
      this.state = {
        coordenadas: {},
        idMovimentoPatio:null,
        contacto:"",
        color:null,
        operadorUnidadId:null,
        operadorId:null,
        colorsOpciones:[],
        vigencia:'',
        modeloOpciones:[],
        licencia:"",
        remolque:null,
        tractorPlaca:"",
        economicot:"",
        colocacionPatios:{},
        marcaOpciones:[],
        modelo:null,
        colocacionPatioOpcion:null,
        economicot:"",
        inputValue:"",
        required:true,
        requiredOperador:false,
        idMovimento:null,
        patio:{},
        idMovimento:null,
        operadoresOpciones:[],
        operadorOpcion:null,
        tractosOpciones:[],
        tractoOpcion:null,
        remolquesDropdownOpciones:[],
        remolqueDropdownOpcion:null,
        operadorActualObj: null,
        tractoActualObj: null,
        remolqueActualObj: null,
        remolqueGpsFijo: null,
        remolqueGpsFijoId: null,
        remolqueFullGpsFijo: null,
        remolqueFullGpsFijoId: null,
        remolque2ActualObj: null,
        remolqueFullTipo: null,
        remolqueFullSeleccionado: null,
        remolquesFullOpciones: [],
        remolquesOpciones:[],
        remolque:null,
        oldMov:null,
        oldTipoRemolque:null,
        newTipoRemolque:null,
        oldOperadorNombre:null,
        oldLicencia:null,
        oldRemolquePlaca:null,
        oldVigencia:null,
        oldContacto:null,
        oldMarca:null,
        oldModelo:null,
        oldColor:null,
        oldEconomicoR:null,
        oldEconomicoT:null,
        hiddenModals: false,
        hiddenModalEditar: false,
        hiddenModalNuevo: false,
        oldPatioColocacion:null,
        esFull:false,
        // true solo cuando el full YA venía guardado en BD al abrir el formulario.
        // Sirve para bloquear el cambio/quita del full en edición (evita duplicar el
        // movimiento). Un full nuevo (aún sin guardar) NO bloquea.
        fullBloqueado:false,
        movimientosSinGps:[{ value: 0, label: "Seleccione un Movimiento", data: null}],
        MovimientoSecundario:{ value: 0, label: "Seleccione un Movimiento", data: null},
        movimientosPatios:this.props.data.movimientosPatios.length > 0 ? this.props.data.movimientosPatios[0] : null,
        movimientosPatiosFull:
        {
        idMovimiento: null,//verificar
        economicor: "",//*
        economicot: "",
        idRemolque: { idRemolque: 0 },
        operadorNombre: "",
        operadorContacto: "",
        operadorLicencia: "",
        tractorModelo: "",
        tractorMarca: "",
        tractorColor: "",
        enProtocolo: true,
        tractorPlaca: "",
        esFull: false,
        remolquePlaca: "",//*
        colocacionFecha: null,
        observaciones: "",//*
        idLocalidad: null,
        idUsuario:{"id": this.props.usuario.id},
        movimientoPrimario : null
        }
      }
      
      this.handleSubmit = this.handleSubmit.bind(this);
      this.changePatio = this.changePatio.bind(this);
      this.updateData = this.updateData.bind(this);
              
    }


    
    

    

    componentWillMount = () => {
      let startYear = 1997;
      let year = new Date().getFullYear();
      let opcionesAnio = []
      for (let i = year; i > startYear; i--)
      {

        opcionesAnio.push({value:i,label:i})
      }


      Crud_Catalogos("colores", "", "get", "", [], "", "", "", []).then((returnVal) => {
        let colorsOptions = [];
        returnVal.forEach(color => {
          colorsOptions.push({label: color.nombreColor, value: color.nombreColor, styles: "color:" + color.hex});
        });
        this.setState({colorsOpciones: colorsOptions});
        this._colorsOptions = colorsOptions;
      });


      this.setState({modeloOpciones:opcionesAnio})

        let marcaOpciones = [];
        Crud_Catalogos("movimientosPatio/idMovimiento/"+this.props.data.id,"","get","",[],"","","",[]).then((returnPatio)=>{     

          // Sanitizar placas: si vienen como objeto o como string literal "[object Object]"
          // (dato sucio en BD por submit anterior con el objeto completo), limpiar a vacío.
          const sanitizePlaca = (val) => {
            if (!val) return '';
            if (typeof val === 'object') return val.placa || '';
            if (typeof val === 'string') {
              if (val === '[object Object]' || val.includes('[object Object]')) return '';
              return val;
            }
            return String(val);
          };
          returnPatio.tractorPlaca = sanitizePlaca(returnPatio.tractorPlaca);
          returnPatio.remolquePlaca = sanitizePlaca(returnPatio.remolquePlaca);
          this.setState({oldMov:{...this.props.data}})                                            
          this.setState({idMovimentoPatio:returnPatio.id})
          if(returnPatio.operadorNombre){
            this.setState({operadorUnidadId: returnPatio.id})
          }
          this.setState({oldColor:returnPatio.tractorColor})
          this.setState({oldMarca:returnPatio?.tractorMarca})
          this.setState({oldRemolquePlaca:returnPatio.remolquePlaca})
          this.setState({oldModelo:returnPatio.tractorModelo})
          this.setState({oldOperadorNombre:returnPatio.operadorNombre})
          this.setState({oldContacto:returnPatio.operadorContacto})
          this.setState({oldLicencia:returnPatio.operadorLicencia})
          this.setState({oldVigencia:returnPatio.operadorLicenciaVigencia})
          this.setState({oldEconomicoR:returnPatio.economicor})
          this.setState({oldEconomicoT:returnPatio.economicot})

         
          opcionesAnio.filter((ele)=> {
          
            if(ele.value == returnPatio.tractorModelo){
              
              this.setState({oldModelo:ele.label})
              this.setState({modelo:ele})
              
              return true;
            }
            
          } )

           Crud_Catalogos("unidadesMarcas", "", "get", "", [], "", "", "", []).then((returnVal) => {                                                
          
            
            
            marcaOpciones.push({label:"Selecciona una opcion",value:""})
            returnVal.forEach(marca => {

                marcaOpciones.push({label:marca.nombre, value:marca.nombre ,id:marca.id});
                                    
            });

            this.setState({marcaOpciones:marcaOpciones})

             marcaOpciones.filter((ele)=> {
          
            // console.log(returnPatio.tractorMarca)
            // console.log("marcas opciones")
            // console.log(ele.value)
            if(returnPatio?.tractorMarca != null&& returnPatio?.tractorMarca != "" && ele.value.toLowerCase().includes(returnPatio?.tractorMarca?.toLowerCase())){
        
              this.setState({oldMarca:ele.label})
              this.setState({marca:ele})
              
              return true;
            }
            
          } )
            
            
        });

          (this._colorsOptions || this.state.colorsOpciones || []).filter((ele)=> {
          
            if(ele.value && returnPatio.tractorColor && ele.value.toLowerCase() == returnPatio.tractorColor.toLowerCase()){
            
              this.setState({oldColor:ele.label})
              this.setState({color:ele})
              
              return true;
            }
            
          } )
          
          // Fallback: si no se encontró en el catálogo pero existe el valor
          if (!this.state.color && returnPatio.tractorColor) {
            this.setState({color: {label: returnPatio.tractorColor, value: returnPatio.tractorColor}});
          }

          //this.state.color = returnPatio.tractorColor   != null ? returnPatio.tractorColor   : this.state.color;
          //this.state.remolquePlaca = returnPatio.remolquePlaca   != null ? returnPatio.remolquePlaca   : this.state.remolquePlaca;
         // this.state.marca = returnPatio.tractorMarca   != null ? returnPatio.tractorMarca   : this.state.marca;
         // this.state.modelo = returnPatio.tractorModelo   != null ? returnPatio.tractorModelo   : this.state.modelo;
          //this.state.tractorPlaca = returnPatio.tractorPlaca   != null ? returnPatio.tractorPlaca   : this.state.tractorPlaca;
          //this.state.inputValue = returnPatio.operadorNombre   != null ? returnPatio.operadorNombre   : this.state.inputValue;
          const vigenciaFromApi = returnPatio.operadorLicenciaVigencia;
          const vigenciaFormatted = this.convertirFechaTextoAISO(vigenciaFromApi);
          
          
          this.setState({
            remolquePlaca: returnPatio.remolquePlaca != null ? returnPatio.remolquePlaca : this.state.remolquePlaca,
            tractorPlaca: returnPatio.tractorPlaca != null ? returnPatio.tractorPlaca : this.state.tractorPlaca,
            inputValue: returnPatio.operadorNombre != null ? returnPatio.operadorNombre : this.state.inputValue,
            economicot: returnPatio.economicot != null ? returnPatio.economicot : this.state.economicot,
            economicor: returnPatio.economicor != null ? returnPatio.economicor : this.state.economicor,
            contacto: returnPatio.operadorContacto || '',
            licencia: returnPatio.operadorLicencia || '',
            vigencia: vigenciaFormatted
          });

          // Consultar GPS fijo vinculado al remolque del patio (por placa)
          if (returnPatio.remolquePlaca) {
            Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(returnPatio.remolquePlaca) + "/activo", "", "get", "", [], "", "", "", [])
              .then((vinc) => {
                this.setState({
                  remolqueGpsFijo: (vinc && vinc.gps) ? vinc.gps.nombre : null,
                  remolqueGpsFijoId: (vinc && vinc.gps) ? vinc.gps.id : null,
                });
              })
              .catch(() => this.setState({ remolqueGpsFijo: null, remolqueGpsFijoId: null }));
          }
          
          // Buscar tractoActualObj en el catálogo si hay placa de tracto
          if (returnPatio.tractorPlaca) {
            Crud_Catalogos("unidadTerNav/idTransportista/" + this.props.data.idTransportista.id, "", "get", "", [], "", "", "", [])
              .then((tractos) => {
                const tractoEncontrado = tractos.find(t => t.placa && t.placa.toLowerCase() === returnPatio.tractorPlaca.toLowerCase());
                if (tractoEncontrado) {
                  this.setState({ tractoActualObj: tractoEncontrado });
                }
              })
              .catch(err => console.error("Error buscando tracto en catálogo:", err));
          }

          // Buscar remolqueActualObj en el catálogo si hay placa de remolque
          if (returnPatio.remolquePlaca) {
            Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
              .then((remolques) => {
                const remolqueEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === returnPatio.remolquePlaca.toLowerCase());
                if (remolqueEncontrado) {
                  this.setState({ remolqueActualObj: remolqueEncontrado });
                }
              })
              .catch(err => console.error("Error buscando remolque en catálogo:", err));
          }
          
          // Cargar tipos de remolques SIEMPRE (independiente de operadores)
          Crud_Catalogos("remolquesTipo", "", "get", "", [], "", "", "", []).then((returnVal) => {                                                
            let remolquesOpcionesTemp = [];
            this.setState({patio: returnPatio});
            remolquesOpcionesTemp.push({label: "Selecciona una opcion", value: ""});
            
            if(returnVal && returnVal.length > 0) {
              returnVal.forEach((remolque) => {
                remolquesOpcionesTemp.push({ 
                  value: remolque.idRemolque, 
                  label: remolque.nombre
                });
              });
            } 

            this.setState({remolquesOpciones: remolquesOpcionesTemp});
            
            // Buscar y establecer el remolque seleccionado
            if(returnPatio.idRemolque) {
              const idRemolqueBuscado = returnPatio.idRemolque.idRemolque || returnPatio.idRemolque;
              const remolqueSeleccionado = remolquesOpcionesTemp.find(ele => ele.value == idRemolqueBuscado);
              
              if(remolqueSeleccionado) {
                this.setState({oldTipoRemolque: remolqueSeleccionado.label});
                this.setState({newTipoRemolque: remolqueSeleccionado.label});
                this.setState({remolque: remolqueSeleccionado});
                this.setState({required: false});
              }
            } else {
              this.setState({remolque: null});
            }
          }).catch(err => { console.error(err); });
          
          // Cargar operadores: usar idTransportista del usuario logueado, no del movimiento
          const plataformaSession = JSON.parse(sessionStorage.getItem("plataforma"));
          const usuarioId = this.props.usuario.id;
          const idTransportistaMovimiento = this.props.data.idTransportista.id;

          const obtenerIdTransportista = () => {
            if (plataformaSession) {
              return Crud_Catalogos("usuarios_transportistas/usuario/" + usuarioId + "/plataforma/" + plataformaSession.id, "", "get", "", [], "", "", "", [])
                .then((transportistas) => {
                  if (transportistas && transportistas.length > 0) {
                    const valido = transportistas.find(t => t.idTransportista !== null);
                    if (valido) return valido.idTransportista;
                  }
                  return idTransportistaMovimiento;
                })
                .catch(() => idTransportistaMovimiento);
            }
            return Promise.resolve(idTransportistaMovimiento);
          };

          obtenerIdTransportista().then((idTransportistaReal) => {
          // === NUEVO FLUJO: Cargar operadores independientes (sin vínculo a tracto/remolque) ===
          const usuario = JSON.parse(sessionStorage.getItem("usuario"));
          const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
          let plataformasIds = currentUser ? [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))] : [];
          // Fallback: si no hay plataformas en currentUser pero hay una en session, usarla
          if (plataformasIds.length === 0 && plataformaSession && plataformaSession.id) {
            plataformasIds = [plataformaSession.id];
          }
          
          const obtenerTodosTransportistas = () => {
            if (plataformasIds.length > 0 && usuario) {
              return Promise.all(plataformasIds.map(idPlat =>
                Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
              )).then((resultados) => {
                const todos = resultados.flat();
                return [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
              });
            }
            return Promise.resolve([]);
          };

          obtenerTodosTransportistas().then((idsUsuario) => {
            // Combinar IDs: los del usuario + el del movimiento (siempre incluir el del movimiento)
            const idsTransportistas = [...new Set([...idsUsuario, idTransportistaMovimiento, idTransportistaReal].filter(Boolean))];
            
            // Cargar remolques del FULL: todos los remolques de los transportistas vinculados al perfil
            Promise.all(idsTransportistas.map(idT =>
              Crud_Catalogos("remolques_transportistas/id_transportista/" + idT, "", "get", "", [], "", "", "", []).catch(() => [])
            )).then((relacionesPorTransportista) => {
              const idsRemolques = [...new Set(relacionesPorTransportista.flat().map(r => r.idRemolque))];
              if (idsRemolques.length === 0) {
                this.setState({ remolquesFullOpciones: [] });
                return;
              }
              Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
                .then((todosRemolques) => {
                  const opciones = todosRemolques
                    .filter(rem => idsRemolques.includes(rem.idRemolque))
                    .map(rem => ({
                      value: rem.idRemolque,
                      label: rem.placa,
                      data: rem
                    }));
                  this.setState({ remolquesFullOpciones: opciones });
                });
            }).catch(err => console.error("Error cargando remolques del full:", err));
            
            // NUEVO: Usar /operadores/transportista/{id} (sin vínculo a tracto/remolque)
            Promise.all(idsTransportistas.map(idT =>
              Crud_Catalogos("operadores/transportista/" + idT, "", "get", "", [], "", "", "", []).catch(() => [])
            )).then((resultados) => {
              const todosOperadores = resultados.flat();
              // Eliminar duplicados por id
              const operadoresObj = {};
              todosOperadores.forEach(op => {
                if(op && op.id && !operadoresObj[op.id]) {
                  operadoresObj[op.id] = op;
                }
              });
              
              let operadoresOpcionesTemp = [];
              Object.values(operadoresObj).forEach((op) => {
                // Solo mostrar operadores no vetados
                if (op.vetado === true) return;
                const nombreCompleto = (op.nombre || "") + " " + (op.paterno || "") + " " + (op.materno || "");
                operadoresOpcionesTemp.push({ value: op, label: nombreCompleto.trim() });
              });
            this.setState({operadoresOpciones:operadoresOpcionesTemp})
            const nombreOperadorBuscado = returnPatio.operadorNombre || this.state.inputValue;
            if(nombreOperadorBuscado != null && nombreOperadorBuscado !== ''){
              // Buscar primero match exacto, luego fallback a includes
              const operadorEncontrado = operadoresOpcionesTemp.find(op => 
                op?.label.trim().toLowerCase() === nombreOperadorBuscado.trim().toLowerCase()
              ) || operadoresOpcionesTemp.find(op => 
                op?.label.toLowerCase().includes(nombreOperadorBuscado.toLowerCase())
              );
              
              if(operadorEncontrado){
                const operador = operadorEncontrado;
                     this.setState({operadorUnidadId: operador.value.id})
                     this.setState({operadorActualObj: operador.value})
                     this.setState({operadorId: operador.value.id})
                     this.setState({inputValue: operador.label})
                     this.setState({operadorOpcion: operador})
                     // Solo setear contacto, licencia y vigencia del operador (sin tocar tracto/remolque)
                     const vigRaw = operador.value.licenciaVigencia;
                     const vigFormatted = this.convertirFechaTextoAISO(vigRaw);
                     this.setState({
                       contacto: operador.value.medioComunicacion || '',
                       licencia: operador.value.licenciaTipo || '',
                       vigencia: vigFormatted,
                     })
                   }
              
            }
          }).catch(err =>{ console.error(err);});

          // === NUEVO: Cargar tractos independientes ===
          Promise.all(idsTransportistas.map(idT =>
            Crud_Catalogos("unidadTerNav/idTransportista/" + idT, "", "get", "", [], "", "", "", []).catch(() => [])
          )).then((resultados) => {
            const todosTractos = resultados.flat();
            const tractosObj = {};
            todosTractos.forEach(t => {
              if(t && t.id && !tractosObj[t.id]) {
                tractosObj[t.id] = t;
              }
            });
            let tractosOpcionesTemp = [];
            Object.values(tractosObj).forEach((t) => {
              if (t.estatus === false) return;
              tractosOpcionesTemp.push({ value: t, label: t.placa || "Sin placa" });
            });
            // Pre-seleccionar tracto si hay placa guardada en patio
            if (returnPatio.tractorPlaca) {
              const tractoEncontrado = tractosOpcionesTemp.find(t => 
                t.value.placa && t.value.placa.toLowerCase() === returnPatio.tractorPlaca.toLowerCase()
              );
              if (tractoEncontrado) {
                this.setState({ 
                  tractosOpciones: tractosOpcionesTemp,
                  tractoOpcion: tractoEncontrado,
                  tractoActualObj: tractoEncontrado.value,
                  tractorPlaca: tractoEncontrado.value.placa || returnPatio.tractorPlaca || '',
                  economicot: tractoEncontrado.value.economico || returnPatio.economicot || '',
                });
              } else {
                // Fallback: el tracto no está en el catálogo del transportista,
                // crear opción temporal con datos del movimientosPatio para que se muestre visualmente
                const tractoFallback = {
                  id: null,
                  placa: returnPatio.tractorPlaca,
                  economico: returnPatio.economicot || '',
                  idUnidadMarca: returnPatio.tractorMarca ? { nombre: returnPatio.tractorMarca } : null,
                  color: returnPatio.tractorColor || '',
                  modelo: returnPatio.tractorModelo || '',
                  estatus: true,
                };
                const labelFallback = returnPatio.tractorPlaca || "Sin placa";
                const opcionFallback = { value: tractoFallback, label: labelFallback };
                tractosOpcionesTemp.unshift(opcionFallback);
                this.setState({ 
                  tractosOpciones: tractosOpcionesTemp,
                  tractoOpcion: opcionFallback,
                  tractoActualObj: null, // null porque no existe en catálogo (no se puede editar)
                });
              }
            } else {
              this.setState({ tractosOpciones: tractosOpcionesTemp });
            }
          }).catch(err => console.error("Error cargando tractos:", err));

          // === NUEVO: Cargar remolques independientes ===
          Promise.all(idsTransportistas.map(idT =>
            Crud_Catalogos("remolques_transportistas/id_transportista/" + idT, "", "get", "", [], "", "", "", []).catch(() => [])
          )).then((resultadosRel) => {
            const todasRelaciones = resultadosRel.flat();
            const idsRemolques = [...new Set(todasRelaciones.filter(r => r.idRemolque).map(r => r.idRemolque))];
            if (idsRemolques.length > 0) {
              Crud_Catalogos("remolques", "", "get", "", [], "", "", "", []).then((todosRemolques) => {
                const remolquesFiltrados = todosRemolques.filter(rem => idsRemolques.includes(rem.idRemolque));
                let remolquesDropdownTemp = [];
                remolquesFiltrados.forEach(rem => {
                  remolquesDropdownTemp.push({ value: rem, label: rem.placa || "Sin placa" });
                });
                // Pre-seleccionar remolque si hay placa guardada en patio
                if (returnPatio.remolquePlaca) {
                  const remEncontrado = remolquesDropdownTemp.find(r => 
                    r.value.placa && r.value.placa.toLowerCase() === returnPatio.remolquePlaca.toLowerCase()
                  );
                  if (remEncontrado) {
                    remolquesDropdownTemp = [...remolquesDropdownTemp]; // copia para no mutar
                    this.setState({ 
                      remolquesDropdownOpciones: remolquesDropdownTemp,
                      remolqueDropdownOpcion: remEncontrado,
                      remolqueActualObj: remEncontrado.value,
                      economicor: remEncontrado.value.economico || '',
                      remolquePlaca: remEncontrado.value.placa || '',
                    });
                    // Setear tipo de remolque
                    if (remEncontrado.value.remolquesTipos) {
                      const tipoSel = this.state.remolquesOpciones.find(r => r.value === remEncontrado.value.remolquesTipos.idRemolque);
                      if (tipoSel) this.setState({ remolque: tipoSel, required: false });
                    }
                  } else {
                    // Fallback: el remolque no está en el catálogo del transportista,
                    // crear opción temporal con datos del movimientosPatio para que se muestre visualmente
                    const remolqueFallback = {
                      idRemolque: null,
                      placa: returnPatio.remolquePlaca,
                      economico: returnPatio.economicor || '',
                      remolquesTipos: null,
                    };
                    const labelRemFallback = returnPatio.remolquePlaca || "Sin placa";
                    const opcionRemFallback = { value: remolqueFallback, label: labelRemFallback };
                    remolquesDropdownTemp.unshift(opcionRemFallback);
                    this.setState({ 
                      remolquesDropdownOpciones: remolquesDropdownTemp,
                      remolqueDropdownOpcion: opcionRemFallback,
                      remolqueActualObj: null, // null porque no existe en catálogo (no se puede editar)
                      economicor: returnPatio.economicor || '',
                      remolquePlaca: returnPatio.remolquePlaca || '',
                    });
                  }
                } else {
                  this.setState({ remolquesDropdownOpciones: remolquesDropdownTemp });
                }
              }).catch(err => console.error("Error cargando remolques:", err));
            } else if (returnPatio.remolquePlaca) {
              // No hay relaciones remolque-transportista pero sí hay placa guardada en patio
              // Crear opción fallback para que se muestre visualmente
              const remolqueFallback = {
                idRemolque: null,
                placa: returnPatio.remolquePlaca,
                economico: returnPatio.economicor || '',
                remolquesTipos: null,
              };
              const labelRemFallback = returnPatio.remolquePlaca || "Sin placa";
              const opcionRemFallback = { value: remolqueFallback, label: labelRemFallback };
              this.setState({ 
                remolquesDropdownOpciones: [opcionRemFallback],
                remolqueDropdownOpcion: opcionRemFallback,
                remolqueActualObj: null,
                economicor: returnPatio.economicor || '',
                remolquePlaca: returnPatio.remolquePlaca || '',
              });
            }
          }).catch(err => console.error("Error cargando relaciones remolques:", err));

          }); // cierre obtenerTodosTransportistas
          }); // cierre obtenerIdTransportista

            Crud_Catalogos("patios/transportista/"+this.props.data.idTransportista.id ,"","get","",[],"","","",[]).then((returnVal)=>{                                                
              let colocacionPatiosTemp = [];
            // this.setState({colocacionPatios:returnPatio});
              Object.keys(returnVal).forEach((key) => colocacionPatiosTemp.push({ value: returnVal[key].id, label: returnVal[key].nombre , latitud: returnVal[key].latitud,longitud:returnVal[key].longitud })); 
              this.setState({colocacionPatios:colocacionPatiosTemp})
              let opcionDefault =  colocacionPatiosTemp.filter((ele)=> {
                this.setState({required:false});
               
                if(ele.value == returnPatio.idColocacionPatio){
                  this.setState({oldPatioColocacion:ele.label})
                  this.setState({colocacionPatioOpcion :  ele});
                  
                  this.setState({coordenadas: { "lat":ele.latitud, "lng":ele.longitud}});
                  return true;
                }
                
              } )
              
  
            }).catch(err =>{ console.error(err);});
          
          }).catch(err =>{ console.error(err);});

      //se asignan los movimientos que pueden ser enfullado //
      let movSinGpsTem = [];
      let movimiento  = this.props.data;
      let idMovimiento =  movimiento.id;

      // Recolectar IDs de movimientos que ya están siendo usados como full por otro
      const idsYaEnfullados = new Set();
      for (let m of this.props.stor.movimientos_naviera_object) {
        if (m.movimientosPatios?.length > 0 && m.movimientosPatios[0].esFull) {
          idsYaEnfullados.add(Number(m.movimientosPatios[0].esFull));
        }
      }

      for( let m of this.props.stor.movimientos_naviera_object ){

        if (idMovimiento !== m.id
          && movimiento.idPlataforma.id === m.idPlataforma.id
          && movimiento.idMovimientoTipo.id === m.idMovimientoTipo.id
          && movimiento.idCorredor.id === m.idCorredor.id
           && ((m.movimientosPatios.length && !m.movimientosPatios[0].esFull?.length) 
            || (!m.movimientosPatios.length))
          && !idsYaEnfullados.has(m.id)
          && movSinGpsTem.filter(msg=> Number(msg.value) === m.id).length === 0
          ) {
          movSinGpsTem.push({
            value: m.id,
            label: m.po + " - " + m.booking + " - " + (m.service_order || '') + " - " + m.contenedor,
            data: m,
          });
        }
      }

      

      //asignamos el movimiento enfullado en caso de que exista
      if(movimiento.movimientosPatios.length > 0 && (movimiento.movimientosPatios[0].esFull != "" && movimiento.movimientosPatios[0].esFull != null)){
        
        let movFull =  this.props.elementos.filter(mov=> mov.id == movimiento.movimientosPatios[0].esFull);

        if(movFull.length > 0){

          this.setState({esFull:true})
          // El full ya existe en BD: bloquear su modificación en edición.
          this.setState({fullBloqueado:true})
          this.setState({movimientoSecundario:
          
          { value: movFull[0].id, label: movFull[0].po+" - " + movFull[0].booking + " - " + (movFull[0].service_order || '') + " - " + movFull[0].contenedor, data: movFull[0]}
          })


          if(this)
            this.setState(prevState => ({
              movimientosPatiosFull: {
                ...prevState.movimientosPatiosFull,
                  remolquePlaca:movFull[0].movimientosPatios[0]?.remolquePlaca,
                  economicor:movFull[0].movimientosPatios[0]?.economicor,
                  idMovimiento: movFull[0].movimientosPatios[0]?.idMovimiento,
                  id:movFull[0].movimientosPatios[0]?.id,
                  esFull: movFull[0].movimientosPatios[0]?.esFull,
                  observaciones:movFull[0].movimientosPatios[0]?.observaciones
              }
            }))

          // Buscar remolque2ActualObj en el catálogo para el botón Editar Remolque Full
          const placaRemFull = movFull[0].movimientosPatios[0]?.remolquePlaca;
          if (placaRemFull) {
            Crud_Catalogos("remolques", "", "get", "", [], "", "", "", [])
              .then((remolques) => {
                const remFullEncontrado = remolques.find(r => r.placa && r.placa.toLowerCase() === placaRemFull.toLowerCase());
                if (remFullEncontrado) {
                  this.setState({ remolque2ActualObj: remFullEncontrado });
                  this.setState({ remolqueFullSeleccionado: { value: remFullEncontrado.idRemolque, label: remFullEncontrado.placa, data: remFullEncontrado } });
                  const tipoRemFull = this.state.remolquesOpciones.find(r => r.value === remFullEncontrado.remolquesTipos?.idRemolque)
                    || (remFullEncontrado.remolquesTipos ? {value: remFullEncontrado.remolquesTipos.idRemolque, label: remFullEncontrado.remolquesTipos.nombre} : null);
                  this.setState({ remolqueFullTipo: tipoRemFull });
                }
              })
              .catch(err => console.error("Error buscando remolque full en catálogo:", err));
            // Consultar GPS fijo vinculado al remolque full (por placa)
            Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(placaRemFull) + "/activo", "", "get", "", [], "", "", "", [])
              .then((vinc) => {
                this.setState({
                  remolqueFullGpsFijo: (vinc && vinc.gps) ? vinc.gps.nombre : null,
                  remolqueFullGpsFijoId: (vinc && vinc.gps) ? vinc.gps.id : null,
                });
              })
              .catch(() => this.setState({ remolqueFullGpsFijo: null, remolqueFullGpsFijoId: null }));
          }
        }else{
          // No se encontró el movimiento full en elementos
        }
      }

      this.setState({movimientosSinGps:movSinGpsTem});    

    }


    updateData(data){

      let colocacionPatiosTemp = this.state.colocacionPatios;
      let nuevaSeleccion =  { value: data.id, label: data.nombre , latitud: data.latitud,longitud:data.longitud };
      colocacionPatiosTemp.push(nuevaSeleccion)
      this.setState({colocacionPatios:colocacionPatiosTemp})
      this.setState({colocacionPatioOpcion :  nuevaSeleccion});

    }


     myFormato(date) {
      function pad(number) {
        if (number < 10) {
          return "0" + number;
        }
        return number;
      }
      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        " " +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    }


    hiddenmodal = () => {
   
      this.setState({ hiddenModals: !this.state.hiddenModals });
    };

    toggleModalEditar = () => {
      this.setState({ hiddenModalEditar: !this.state.hiddenModalEditar });
    };

    toggleModalNuevo = () => {
      this.setState({ hiddenModalNuevo: !this.state.hiddenModalNuevo });
    };

    recargarOperadores = (operadorActualizado) => {
      const usuario = JSON.parse(sessionStorage.getItem("usuario"));
      const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      const idTransportistaMovimiento = this.props.data.idTransportista.id;
      const plataformasIds = currentUser ? [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))] : [];

      const obtenerTodosTransportistas = () => {
        if (plataformasIds.length > 0 && usuario) {
          return Promise.all(plataformasIds.map(idPlat =>
            Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
          )).then((resultados) => {
            const todos = resultados.flat();
            return [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
          });
        }
        return Promise.resolve([]);
      };

      obtenerTodosTransportistas().then((idsUsuario) => {
        const idsTransportistas = [...new Set([...idsUsuario, idTransportistaMovimiento].filter(Boolean))];
        
        Promise.all(idsTransportistas.map(idT =>
          Crud_Catalogos("operadores/transportista/" + idT, "", "get", "", [], "", "", "", []).catch(() => [])
        )).then((resultados) => {
          const todosOperadores = resultados.flat();
          const operadoresObj = {};
          todosOperadores.forEach(op => {
            if(op && op.id && !operadoresObj[op.id]) {
              operadoresObj[op.id] = op;
            }
          });
          
          let operadoresOpcionesTemp = [];
          Object.values(operadoresObj).forEach((op) => {
            if (op.vetado === true) return;
            const nombreCompleto = (op.nombre || "") + " " + (op.paterno || "") + " " + (op.materno || "");
            operadoresOpcionesTemp.push({ value: op, label: nombreCompleto.trim() });
          });
          
          this.setState({ operadoresOpciones: operadoresOpcionesTemp });

          // Si se pasó un operador actualizado y coincide con el seleccionado actualmente, refrescar campos
          const idSeleccionado = this.state.operadorActualObj?.id || this.state.operadorId;
          if (operadorActualizado && idSeleccionado && operadorActualizado.id === idSeleccionado) {
            const opActualizado = operadoresOpcionesTemp.find(o => o.value.id === operadorActualizado.id);
            if (opActualizado) {
              const vigRaw = opActualizado.value.licenciaVigencia;
              const vigFormatted = this.convertirFechaTextoAISO(vigRaw);
              this.setState({
                inputValue: opActualizado.label,
                contacto: opActualizado.value.medioComunicacion || '',
                licencia: opActualizado.value.licenciaTipo || '',
                vigencia: vigFormatted,
                operadorOpcion: opActualizado,
                operadorActualObj: opActualizado.value,
              });
            }
          }
        }).catch(err => { console.error(err); });
      });
    };

   
    onInputChange = (inputValue, { action }) => {

      if (action === "input-change") {
        this.setState({
          operadorOpcion: null,
          inputValue: inputValue,
        });
      }
      
      // Detectar cuando se limpia el select
      if (action === "clear" || (action === "input-change" && inputValue === "")) {
        this.setState({
          inputValue: "",
          contacto: "",
          vigencia: "",
          licencia: "",
          operadorOpcion: null,
          operadorUnidadId: "cleared",
          operadorId: null,
          operadorActualObj: null,
          requiredOperador: true,
        });
      }
    };

    changePatio(e){

      

      this.setState({coordenadas:{lat:e.latitud,lng:e.longitud}})

      this.setState({colocacionPatioOpcion: e})
    
    }

    convertirFechaTextoAISO(fechaTexto) {
      if (!fechaTexto) return '';
      
      // Si ya está en formato ISO (YYYY-MM-DD), retornar
      if (/^\d{4}-\d{2}-\d{2}/.test(fechaTexto)) {
        return fechaTexto.substring(0, 10);
      }
      
      // Convertir "11 febrero 2026" o "11 february 2026" a "2026-02-11"
      const meses = {
        'enero': '01', 'febrero': '02', 'marzo': '03', 'abril': '04',
        'mayo': '05', 'junio': '06', 'julio': '07', 'agosto': '08',
        'septiembre': '09', 'octubre': '10', 'noviembre': '11', 'diciembre': '12',
        'january': '01', 'february': '02', 'march': '03', 'april': '04',
        'may': '05', 'june': '06', 'july': '07', 'august': '08',
        'september': '09', 'october': '10', 'november': '11', 'december': '12'
      };
      
      const partes = fechaTexto.toLowerCase().trim().split(' ');
      if (partes.length === 3) {
        const dia = partes[0].padStart(2, '0');
        const mes = meses[partes[1]];
        const anio = partes[2];
        
        if (mes && anio) {
          return `${anio}-${mes}-${dia}`;
        }
      }
      
      return '';
    }

    handleChange(e){
        // Si e es null, limpiar solo campos del operador
        if(!e) {
          this.setState({
            inputValue: "",
            contacto: "",
            vigencia: "",
            licencia: "",
            operadorOpcion: null,
            operadorUnidadId: null,
            operadorId: null,
            operadorActualObj: null,
            requiredOperador: true,
          });
          return;
        }

        // NUEVO: e.value es directamente el objeto operador (de /operadores/transportista)
        const op = e.value;
        const vigenciaRaw = op.licenciaVigencia;
        const vigenciaFormatted = this.convertirFechaTextoAISO(vigenciaRaw);
        
        this.setState({
          inputValue: e.label,
          contacto: op.medioComunicacion || '',
          licencia: op.licenciaTipo || '',
          vigencia: vigenciaFormatted,
          operadorUnidadId: op.id,
          operadorId: op.id,
          operadorOpcion: e,
          operadorActualObj: op,
          requiredOperador: false,
        });
    }

    // === NUEVO: Handler para selección de Tracto ===
    handleChangeTracto = (e) => {
      if(!e) {
        this.setState({
          tractoOpcion: null,
          tractoActualObj: null,
          tractorPlaca: "",
          economicot: "",
          marca: null,
          modelo: null,
          color: null,
        });
        return;
      }
      const tracto = e.value;
      const colorSeleccionado = (this.state.colorsOpciones || []).find(ele => 
        tracto.color && ele.label.toLowerCase() === tracto.color.toLowerCase()
      ) || (tracto.color ? {label: tracto.color, value: tracto.color} : null);
      
      const marcaSeleccionada = (this.state.marcaOpciones || []).find(ele => 
        tracto.idUnidadMarca?.nombre && ele.label.toLowerCase() === tracto.idUnidadMarca.nombre.toLowerCase()
      ) || (tracto.idUnidadMarca?.nombre ? {label: tracto.idUnidadMarca.nombre, value: tracto.idUnidadMarca.nombre, id: tracto.idUnidadMarca.id} : null);
      
      const modeloSeleccionado = (this.state.modeloOpciones || []).find(ele => 
        tracto.modelo && ele.label == parseInt(tracto.modelo)
      ) || (tracto.modelo ? {label: parseInt(tracto.modelo), value: parseInt(tracto.modelo)} : null);

      this.setState({
        tractoOpcion: e,
        tractoActualObj: tracto,
        tractorPlaca: tracto.placa || '',
        economicot: tracto.economico || '',
        color: colorSeleccionado,
        marca: marcaSeleccionada,
        modelo: modeloSeleccionado,
      });
    }

    // === NUEVO: Handler para selección de Remolque ===
    handleChangeRemolque = (e) => {
      if(!e) {
        this.setState({
          remolqueDropdownOpcion: null,
          remolqueActualObj: null,
          remolquePlaca: "",
          economicor: "",
          remolque: null,
          remolqueGpsFijo: null,
          remolqueGpsFijoId: null,
          required: true,
        });
        return;
      }
      const rem = e.value;
      const tipoSel = (this.state.remolquesOpciones || []).find(r => r.value === rem.remolquesTipos?.idRemolque)
        || (rem.remolquesTipos ? {value: rem.remolquesTipos.idRemolque, label: rem.remolquesTipos.nombre} : null);

      // Si el remolque del catálogo no tiene tipo asignado (remolquesTipos es null),
      // preservar el tipo de remolque que ya estaba cargado (de returnPatio.idRemolque)
      // para no perder el idRemolque del movimiento primario al enfular
      const remolqueFinal = tipoSel || this.state.remolque;
      
      this.setState({
        remolqueDropdownOpcion: e,
        remolqueActualObj: rem,
        remolquePlaca: rem.placa || '',
        economicor: rem.economico || '',
        remolque: remolqueFinal,
        remolqueGpsFijo: null,
        remolqueGpsFijoId: null,
        required: !remolqueFinal,
      });

      // Consultar si el remolque tiene un GPS fijo vinculado (por placa)
      if (rem.placa) {
        Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(rem.placa) + "/activo", "", "get", "", [], "", "", "", [])
          .then((vinc) => {
            if (vinc && vinc.gps) {
              this.setState({ remolqueGpsFijo: vinc.gps.nombre, remolqueGpsFijoId: vinc.gps.id });
            } else {
              this.setState({ remolqueGpsFijo: null, remolqueGpsFijoId: null });
            }
          })
          .catch(() => this.setState({ remolqueGpsFijo: null, remolqueGpsFijoId: null }));
      }
    }


    detectedChange = (oldMov,newMov)=>{


      let camposmodificados = "";
      let bitacora = 17;

     
          if (
            this.state.oldOperadorNombre !==
            newMov.operadorNombre
          ) {
            this.state.oldOperadorNombre  != null? bitacora = 19 : bitacora = 17;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + "Nombre Operador:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldOperadorNombre  +
              " a " +
              newMov.operadorNombre +
              ")";
          }


          if (
            this.state.oldContacto !==
            newMov.operadorContacto
          ) {
            this.state.oldContacto != null ? bitacora = 19 : bitacora = 17;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + " Contacto: ( ";
            camposmodificados =
              camposmodificados +
              this.state.oldContacto +
              " a " +
              newMov.operadorContacto +
              ")";
          }


          if (
            this.state.oldLicencia !==
            newMov.operadorLicencia
          ) {
            this.state.oldLicencia != null ? bitacora = 19 : bitacora = 17;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Licencia: ( ";
            camposmodificados =
              camposmodificados +
              this.state.oldLicencia +
              " a " +
              newMov.operadorLicencia +
              ")";
          }


          if (
            this.state.oldVigencia !==
            newMov.operadorLicenciaVigencia
          ) {
            this.state.oldVigencia != null ? bitacora = 19 : bitacora = 17;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + "Vigencia:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldVigencia +
              " a " +
              newMov.operadorLicenciaVigencia +
              ")";
          }

          if (
            this.state.oldRemolquePlaca !==
            newMov.remolquePlaca
          ) {
            this.state.oldRemolquePlaca == null ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Remolque Placa:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldRemolquePlaca +
              " a " +
              newMov.remolquePlaca +
              ")";
          }


          if (
            this.state.oldTipoRemolque !==
            this.state.newTipoRemolque
          ) {
            this.state.oldTipoRemolque == null ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Tipo de Remolque:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldTipoRemolque +
              " a " +
              this.state.newTipoRemolque +
              ")";
          }


          if (
            this.state.oldMarca !==
            newMov.tractorMarca
          ) {
            this.state.oldMarca == null  ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Marca:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldMarca +
              " a " +
              newMov.tractorMarca +
              ")";
          }

          if (
            this.state.oldModelo !==
            newMov.tractorModelo
          ) {
            this.state.oldModelo == null  ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + " Modelo:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldModelo +
              " a " +
              newMov.tractorModelo +
              ")";
          }

          if (
            this.state.oldColor !==
            newMov.tractorColor
          ) {
            this.state.oldColor == null  ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Color:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldColor +
              " a " +
              newMov.tractorColor +
              ")";
          }


          if (
            this.state.oldEconomicoR !==
            newMov.economicor
          ) {
            this.state.oldEconomicoR == null  ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Economico Remolque:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldEconomicoR +
              " a " +
              newMov.economicor +
              ")";
          }


          if (
            this.state.oldEconomicoT !==
            newMov.economicot
          ) {
            this.state.oldEconomicoT == null  ? bitacora = 20 : bitacora = 18;  
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ",  ";
            }
            camposmodificados = camposmodificados + "Economico Tractor:( ";
            camposmodificados =
              camposmodificados +
              this.state.oldEconomicoT +
              " a " +
              newMov.economicot +
              ")";
          }


          // Detectar cambio de patio
          const nuevoPatio = this.state.colocacionPatioOpcion?.label || "";
          if (this.state.oldPatioColocacion !== nuevoPatio && nuevoPatio !== "") {
            this.state.oldPatioColocacion != null ? bitacora = 19 : bitacora = 17;
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + "Patio:( ";
            camposmodificados = camposmodificados + (this.state.oldPatioColocacion || "Sin patio") + " a " + nuevoPatio + ")";
          }

          // Detectar cambio de full
          if (this.state.esFull && this.state.movimientoSecundario?.label) {
            if (camposmodificados.length > 0) {
              camposmodificados = camposmodificados + ", ";
            }
            camposmodificados = camposmodificados + "Enfullado con: " + this.state.movimientoSecundario.label;
          }

      return { id: bitacora, descripcion: camposmodificados };

    }


    // === NUEVO: Asignar GPS fijo del remolque al movimiento (para que One lo muestre como "asignado") ===
    // Solo se ejecuta si el remolque tiene GPS fijo (idGps no nulo). Evita duplicados: no inserta
    // si ese GPS ya está vinculado al movimiento. Replica el flujo terrestre de One:
    // POST movimientoGps/idUsuario/{userId} con gpsTipo=6 (GPS FIJO), cambio de estatus del GPS y bitácora.
    asignarGpsFijoAMovimiento(idMovimiento, idGps, nombreGps) {
      // Guard: sin GPS fijo o sin movimiento, no aplica ningún cambio.
      if (!idGps || !idMovimiento) {
        return Promise.resolve(false);
      }
      const GPS_TIPO_FIJO = 6; // catalogos.gps_tipo_colocacion: "GPS FIJO"
      const userId = this.props.usuario.id;

      // 1) Verificar si el movimiento ya tiene ese GPS asignado (evitar duplicados)
      return Crud_Catalogos("movimientoGps/movimiento/" + idMovimiento, "", "get", "", [], "", "", "", [])
        .then((existentes) => {
          const yaAsignado = Array.isArray(existentes) && existentes.some(
            (mg) => mg && mg.gps && Number(mg.gps.id) === Number(idGps)
          );
          if (yaAsignado) {
            return false; // ya existe, no duplicar
          }

          const movimientoGpsBody = {
            idMovimiento: idMovimiento,
            gps: { id: idGps },
            gpsTipo: { id: GPS_TIPO_FIJO },
          };

          // 2) Crear el vínculo en movimiento_gps
          return Crud_Catalogos("movimientoGps/idUsuario/" + userId, "", "post", "", movimientoGpsBody, "", "", "", [])
            .then(() => {
              // 3) Cambiar estatus del GPS a Instalado(2). El backend ya lo hace internamente para
              //    gps.id>20, pero se replica por consistencia con el flujo de One.
              Crud_Catalogos("gps/idGps/" + idGps + "/idGpsEstatus/2", "", "get", "", [], "", "", "", [])
                .catch((err) => console.error("Error cambiando estatus de GPS fijo:", err));

              // 4) Registrar en bitácora (idBitacoraMonitoreo=5: Asignación de GPS)
              const usuariosLogObject = {
                id: "",
                idBitacoraMonitoreo: 5,
                idUsuario: userId,
                idMovimiento: idMovimiento,
                accionFecha: this.myFormato(new Date()),
                descripcion: "Asignacion de GPS: " + (nombreGps || "") + "(" + idGps + ")",
                idPlataformaTipo: 1,
                Navigator: false,
              };
              Crud_Catalogos("usuariosLog", "", "post", "", usuariosLogObject, "", "", "", []);
              return true;
            })
            .catch((err) => {
              console.error("Error asignando GPS fijo al movimiento:", err);
              return false;
            });
        })
        .catch((err) => {
          console.error("Error verificando GPS existentes del movimiento:", err);
          return false;
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        if(!this.state.operadorUnidadId || this.state.operadorUnidadId === "cleared") {
          NotificationManager.warning("Debes seleccionar un operador del catálogo", "Atención");
          return;
        }

        // Validar que si es full, se haya seleccionado el movimiento secundario y remolque
        if (this.state.esFull) {
          if (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0) {
            NotificationManager.warning("Debes seleccionar el movimiento para enfular", "Atención");
            return;
          }
          if (!this.state.remolqueFullSeleccionado) {
            NotificationManager.warning("Debes seleccionar un remolque para el movimiento full", "Atención");
            return;
          }
        }

        const form = event.target;
        const data = new FormData(form);
        const name = this.state.inputValue;

        // Guardar todo el nombre completo en el campo nombre
        const nombre = name.trim();
        const a_paterno = '';
        const a_materno = '';

        let method = "post";
        let methodFull = "post";
        
        // JSON para movimientosPatio (bitácora)
        // Determinar el idRemolque (tipo de remolque) a enviar:
        // 1. Del state.remolque (seleccionado/cargado en el dropdown de tipos)
        // 2. Del remolqueActualObj.remolquesTipos (del catálogo de remolques)
        // 3. Del patio cargado originalmente (preservar lo que ya tenía en BD)
        // 4. Fallback a 1 solo si no hay otra opción
        const idRemolqueTipoRaw = this.state.remolque?.value 
            || this.state.remolqueActualObj?.remolquesTipos?.idRemolque
            || (typeof this.state.patio?.idRemolque === 'object' ? this.state.patio?.idRemolque?.idRemolque : this.state.patio?.idRemolque)
            || 1;
        // Asegurar que sea un número válido (no un objeto ni string vacío)
        const idRemolqueTipo = (typeof idRemolqueTipoRaw === 'number' && idRemolqueTipoRaw > 0) 
            ? idRemolqueTipoRaw 
            : (parseInt(idRemolqueTipoRaw) || 1);

        let JSON_REQUEST = {  
            "idMovimiento": this.props.data.id,
            "idRemolque": {"idRemolque": idRemolqueTipo},
            "operadorNombre": name,
            "operadorContacto": data.get('contacto'),
            "operadorLicencia": data.get('tipo_licencia'),
            "tractorModelo": this.state.modelo?.value || "",
            "tractorMarca": this.state.marca?.value || "",
            "tractorColor": this.state.color?.value || "",
            "economicot": data.get('economicot'),
            "economicor": data.get('economicor'),
            "tractorPlaca": data.get('placa_tractor'),
            "remolquePlaca": data.get('placa_remolque'),
            "operadorLicenciaVigencia": data.get('vigencia'),
            "idColocacionPatio": parseInt(data.get('patios')),
            "idUsuario": {"id": this.props.usuario.id},
            "esFull": this.state.esFull && this.state.movimientoSecundario?.value ? String(this.state.movimientoSecundario.value) : this.state.movimientosPatios?.esFull,
            "enPatio": this.state.movimientosPatios?.enPatio != null
              ? this.state.movimientosPatios.enPatio
              : (!this.state.oldOperadorNombre && this.state.enPatio)
                ? this.getFormattedDateTime()
                : null
        };



        let ObjectOperador= {
          id_operador: null,
          nombre:nombre,
          paterno:a_paterno,
          materno:a_materno,
          medioComunicacion: data.get('contacto'),
          licenciaTipo: data.get('tipo_licencia'),
          licenciaVigencia:data.get('tipo_licencia'),
          idTransportista:this.props.data.idTransportista?.id,
          noEmpleado:null,
          vetado:false,
          idSkylogistic:null
        }


        let unidadEstatusObject = {
          id:1,
          nombre:"Disponible"
        }
        
        let remolqueTipoObject = {
          idRemolque:this.state.remolque?.value,
          nombre:this.state.remolque?.name
        }

        let remolquesObject ={
          idRemolque:null,
          economico:data.get('placa_remolque'),
          placa:data.get('placa_remolque'),
          remolquesTipo:remolqueTipoObject
        }

      

        let unidadObject={
          id:null,
          idUnidadTipo:1,
          idUnidadMarca:this.state.marca?.id,
          nombre:"",
          economico:data.get('economicot'),
          placa:data.get('placa_tractor'),
          color:this.state.color?.value || "",
          modelo:this.state.modelo?.value || "",
          estatus:true,
          idVideo:null,
          idUnidadEstatusOperacion:unidadEstatusObject,
          remolques:remolquesObject,
          esActiva:true,

        }

        // DTO eliminado - ya NO se escribe en operadoresUnidades/completo

        this.setState({movimientoPrimario: JSON_REQUEST});
    
        if(this.state.idMovimentoPatio != null) {                 
            JSON_REQUEST["id"] = this.state.idMovimentoPatio;
            method = "put";   
        }

        if(this.props.data.movimientosPatios.length > 0 && this.props.data.movimientosPatios[0]?.esFull || 
          this.state.movimientosPatiosFull.id != null) {
            methodFull = "put";
        }

        // Guardar SOLO en movimientosPatio (bitácora)
          Crud_Catalogos("movimientosPatio", "", method, "", JSON_REQUEST, "", "", "", []).then((returnVal) => {         
                JSON_REQUEST = this.state.movimientoPrimario;  
                NotificationManager.info("Se ha vinculado el operador al movimiento exitosamente", "Guardado");
                this.props.updateData(returnVal);
         
                if(returnVal.id) {
                    // === Asignar GPS fijo del remolque principal al movimiento (si aplica) ===
                    // Solo cuando el remolque tiene GPS fijo. Refleja el movimiento como "asignado" en One.
                    if (this.state.remolqueGpsFijoId) {
                      this.asignarGpsFijoAMovimiento(
                        this.props.data.id,
                        this.state.remolqueGpsFijoId,
                        this.state.remolqueGpsFijo
                      );
                    }
                    // Manejar movimiento full si aplica
                    if(this.state.esFull) {
                        // Validar que se haya seleccionado el movimiento secundario y el remolque full
                        if (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0) {
                          NotificationManager.warning("Debes seleccionar el movimiento para enfular", "Atención");
                          return;
                        }
                        if (!this.state.remolqueFullSeleccionado) {
                          NotificationManager.warning("Debes seleccionar un remolque para el movimiento full", "Atención");
                          return;
                        }

                        // Usar el remolque full seleccionado, NO el del principal
                        const remolqueFullData = this.state.remolqueFullSeleccionado.data;
                        const idRemolqueFullTipo = remolqueFullData?.remolquesTipos?.idRemolque || 1;

                        this.setState(prevState => ({
                            movimientosPatiosFull: {
                                ...prevState.movimientosPatiosFull,
                                idRemolque: { "idRemolque": idRemolqueFullTipo },
                                operadorNombre: JSON_REQUEST.operadorNombre,
                                operadorContacto: JSON_REQUEST.operadorContacto,
                                operadorLicencia: JSON_REQUEST.operadorLicencia,
                                tractorModelo: JSON_REQUEST.tractorModelo,
                                tractorMarca: JSON_REQUEST.tractorMarca,
                                tractorColor: JSON_REQUEST.tractorColor,
                                economicot: JSON_REQUEST.economicot,
                                tractorPlaca: JSON_REQUEST.tractorPlaca,
                                operadorLicenciaVigencia: JSON_REQUEST.operadorLicenciaVigencia,
                                idColocacionPatio: parseInt(JSON_REQUEST.idColocacionPatio),
                                enPatio: JSON_REQUEST.enPatio,
                                remolquePlaca: remolqueFullData.placa,
                                economicor: remolqueFullData.economico || ""
                            }
                        }));

                        let movFullPatio = {...this.state.movimientosPatiosFull};
                        movFullPatio.idRemolque = { "idRemolque": idRemolqueFullTipo };
                        movFullPatio.operadorNombre = JSON_REQUEST.operadorNombre;
                        movFullPatio.operadorContacto = JSON_REQUEST.operadorContacto;
                        movFullPatio.operadorLicencia = JSON_REQUEST.operadorLicencia;
                        movFullPatio.tractorModelo = JSON_REQUEST.tractorModelo;
                        movFullPatio.tractorMarca = JSON_REQUEST.tractorMarca;
                        movFullPatio.tractorColor = JSON_REQUEST.tractorColor;
                        movFullPatio.economicot = JSON_REQUEST.economicot;
                        movFullPatio.enProtocolo = false;
                        movFullPatio.tractorPlaca = JSON_REQUEST.tractorPlaca;
                        movFullPatio.operadorLicenciaVigencia = JSON_REQUEST.operadorLicenciaVigencia;
                        movFullPatio.idColocacionPatio = parseInt(JSON_REQUEST.idColocacionPatio);
                        movFullPatio.enPatio = JSON_REQUEST.enPatio;
                        // Usar remolque full diferente al principal
                        movFullPatio.remolquePlaca = remolqueFullData.placa;
                        movFullPatio.economicor = remolqueFullData.economico || "";

                        // Capturar datos del GPS fijo del full ANTES del guardado, porque la limpieza
                        // del state (más abajo en este mismo .then) corre antes de que resuelva esta promesa.
                        const gpsFijoFullId = this.state.remolqueFullGpsFijoId;
                        const gpsFijoFullNombre = this.state.remolqueFullGpsFijo;
                        const idMovFullParaGps = this.state.movimientoSecundario?.value
                          ? Number(this.state.movimientoSecundario.value)
                          : null;

                        Crud_Catalogos("movimientosPatio/", "", methodFull, "", movFullPatio, "", "", "", [])
                            .then((returnFull) => {   
                                if(returnFull.id) {
                                    // === Asignar GPS fijo del remolque full al movimiento full (si aplica) ===
                                    if (gpsFijoFullId && idMovFullParaGps) {
                                      this.asignarGpsFijoAMovimiento(
                                        idMovFullParaGps,
                                        gpsFijoFullId,
                                        gpsFijoFullNombre
                                      );
                                    }
                                    NotificationManager.info("Operador enfullado correctamente", "Guardado");
                                    this.props.updateData(returnFull);
                                } else {
                                    NotificationManager.error("Hubo un error al vincular al full con el movimiento", "Error");
                                }
                            });
                    }
                } else {
                    NotificationManager.error("Hubo un error al vincular al operador con el movimiento", "Error");
                    return;
                }
          
                // Registrar en bitácora
                let bitacora = this.detectedChange(this.state.oldMov, JSON_REQUEST);
                let usuariosLogObject = {
                    id: "",
                    idBitacoraMonitoreo: bitacora.id,
                    idUsuario: this.props.usuario.id,
                    idMovimiento: this.props.data.id,
                    accionFecha: this.myFormato(new Date()),
                    descripcion: bitacora.descripcion,
                    idPlataformaTipo: 1,
                    Navigator: false,
                };
              
                Crud_Catalogos("usuariosLog", this.catalogo, "post", "", usuariosLogObject);

                // Vincular tracto/remolque con el idTransportista si no existe la relación
                const idTranspVinculacion = this.props.data.idTransportista?.id;
                if (idTranspVinculacion) {
                  const tractoId = this.state.tractoActualObj?.id || null;
                  const remolqueId = this.state.remolqueActualObj?.idRemolque || null;
                  const remolque2Id = this.state.esFull && this.state.remolqueFullSeleccionado?.data
                    ? this.state.remolqueFullSeleccionado.data.idRemolque
                    : null;

                  // Vincular tracto en tabla intermedia si tiene ID de catálogo
                  if (tractoId) {
                    Crud_Catalogos(
                      "transportistas_unidades_ter_nav/id_unidad/" + tractoId, "", "get", "", [], "", "", "", []
                    ).then((relaciones) => {
                      const yaVinculado = Array.isArray(relaciones) && relaciones.some(
                        r => r.idTransportista === idTranspVinculacion && r.estatus !== false
                      );
                      if (!yaVinculado) {
                        const desactivada = Array.isArray(relaciones) && relaciones.find(
                          r => r.idTransportista === idTranspVinculacion && r.estatus === false
                        );
                        if (desactivada) {
                          Crud_Catalogos(
                            "transportistas_unidades_ter_nav/activar/" + tractoId + "/" + idTranspVinculacion,
                            "", "put", "", {}, "", "", "", []
                          ).catch(err => console.error("Error reactivando relación tracto:", err));
                        } else {
                          Crud_Catalogos("transportistas_unidades_ter_nav", "", "post", "", {
                            idUnidad: tractoId,
                            idTransportista: idTranspVinculacion
                          }, "", "", "", []).catch(err => console.error("Error creando relación tracto:", err));
                        }
                      }
                    }).catch(err => console.error("Error verificando relación tracto:", err));
                  }

                  // Vincular remolque en tabla intermedia si tiene ID de catálogo
                  if (remolqueId) {
                    Crud_Catalogos(
                      "remolques_transportistas/id_transportista/" + idTranspVinculacion, "", "get", "", [], "", "", "", []
                    ).then((relaciones) => {
                      const yaVinculado = Array.isArray(relaciones) && relaciones.some(
                        r => r.idRemolque === remolqueId && r.estatus !== false
                      );
                      if (!yaVinculado) {
                        const desactivada = Array.isArray(relaciones) && relaciones.find(
                          r => r.idRemolque === remolqueId && r.estatus === false
                        );
                        if (desactivada) {
                          Crud_Catalogos(
                            "remolques_transportistas/activar/" + remolqueId + "/" + idTranspVinculacion,
                            "", "put", "", {}, "", "", "", []
                          ).catch(err => console.error("Error reactivando relación remolque:", err));
                        } else {
                          Crud_Catalogos("remolques_transportistas", "", "post", "", {
                            idRemolque: remolqueId,
                            idTransportista: idTranspVinculacion
                          }, "", "", "", []).catch(err => console.error("Error creando relación remolque:", err));
                        }
                      }
                    }).catch(err => console.error("Error verificando relación remolque:", err));
                  }

                  // Vincular remolque2 (full) en tabla intermedia si existe
                  if (remolque2Id) {
                    Crud_Catalogos(
                      "remolques_transportistas/id_transportista/" + idTranspVinculacion, "", "get", "", [], "", "", "", []
                    ).then((relaciones) => {
                      const yaVinculado = Array.isArray(relaciones) && relaciones.some(
                        r => r.idRemolque === remolque2Id && r.estatus !== false
                      );
                      if (!yaVinculado) {
                        const desactivada = Array.isArray(relaciones) && relaciones.find(
                          r => r.idRemolque === remolque2Id && r.estatus === false
                        );
                        if (desactivada) {
                          Crud_Catalogos(
                            "remolques_transportistas/activar/" + remolque2Id + "/" + idTranspVinculacion,
                            "", "put", "", {}, "", "", "", []
                          ).catch(err => console.error("Error reactivando relación remolque full:", err));
                        } else {
                          Crud_Catalogos("remolques_transportistas", "", "post", "", {
                            idRemolque: remolque2Id,
                            idTransportista: idTranspVinculacion
                          }, "", "", "", []).catch(err => console.error("Error creando relación remolque full:", err));
                        }
                      }
                    }).catch(err => console.error("Error verificando relación remolque full:", err));
                  }
                }
                
                // Limpiar el state después de enviar exitosamente
                this.setState({
                  inputValue: "",
                  contacto: "",
                  vigencia: "",
                  licencia: "",
                  tractorPlaca: "",
                  economicot: "",
                  economicor: "",
                  remolquePlaca: "",
                  operadorOpcion: null,
                  remolque: null,
                  marca: null,
                  modelo: null,
                  color: null,
                  colocacionPatioOpcion: null,
                  operadorUnidadId: null,
                  operadorId: null,
                  esFull: false,
                  remolqueFullSeleccionado: null,
                  remolqueFullTipo: null,
                  remolque2ActualObj: null,
                  remolqueGpsFijo: null,
                  remolqueFullGpsFijo: null,
                  remolqueGpsFijoId: null,
                  remolqueFullGpsFijoId: null,
                  movimientoSecundario: { value: 0, label: "Seleccione un Movimiento", data: null },
                  requiredOperador: false,
                  required: true
                }, () => {
                  // Cerrar modal después de limpiar el state
                  if(this.props.closeModal) {
                    this.props.closeModal();
                  }
                  if(this.props.cerrarModal) {
                    this.props.cerrarModal();
                  }
                }); 
            })
            .catch(err => { 
                console.error('Error en el proceso:', err);
                NotificationManager.error(
                    err.response?.data?.message || "Hubo un error al guardar los datos", 
                    "Error"
                );
            });
    }


     SelectMarca = props => (
      <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={this.state.marcaOpciones}
      />
    );

    getFormattedDateTime = () => {
    const now = new Date();
    
    // Formatear fecha YYYY-MM-DD
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    
    // Formatear hora HH:MM:SS
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    // Combinar en el formato deseado
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  
  
     SelectModelo = props => (
      <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={this.state.modeloOpciones}
      />
    );
  
  
     SelectColor = props => (
      <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={this.state.colorsOpciones}
      />
    );


    SelectRemolques = props => (
      <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={this.state.remolquesOpciones}
      />
    );

    
    SelectPatios = props => (
      <FixRequiredSelect
        {...props}
        SelectComponent={BaseSelect}
        options={this.state.colocacionPatios}
      />
    );

    SelectMovFull = props => (
          <FixRequiredSelect
            {...props}
            SelectComponent={BaseSelect}
            options={this.state.movimientosSinGps}
             />
    );

render() {
 
          return (
                 this.state.patio || this.props.readonly?

                 <div className="modern-operator-container">
                    <div className="modern-header">
                      <div className="header-bg-animation">
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                      </div>
                      <div className="header-content-modern">
                        <div className="header-left-section">
                          <div className="animated-icon">
                            <Icon name="truck" className="main-icon" />
                            <div className="icon-glow"></div>
                          </div>
                          <div className="header-text-section">
                            <h1 className="modern-title">
                              <span className="title-word" style={{animationDelay: '0.1s'}}>GESTIÓN</span>
                              <span className="title-word" style={{animationDelay: '0.3s'}}>DE</span>
                              <span className="title-word" style={{animationDelay: '0.5s'}}>OPERADORES</span>
                            </h1>
                            <div className="company-info">
                              <Icon name="building" className="company-icon" />
                              <span className="company-name">{this.props.data.idTransportista? this.props.data.idTransportista.nombre : "Sistema Desconectado"}</span>
                            </div>
                          </div>
                        </div>
                        <div className="header-right-section">
                          <div className="status-indicator">
                            <div className="status-dot"></div>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <Form onSubmit={this.handleSubmit} className="modern-form">

                    <div className="section-card">
                      <div className="section-header">
                        <Icon name="user" className="section-icon" />
                        <h4 className="section-title">INFORMACIÓN DEL OPERADOR</h4>
                        {/* Botón Nuevo o Editar Operador según si hay operador seleccionado */}
                        {!this.props.readonly && (
                          <div style={{ marginLeft: '16px' }}>
                            {!this.state.operadorOpcion && (!this.state.oldOperadorNombre || !this.state.inputValue) ? (
                              <ModalLay
                                tamanio="80%"
                                title="Nuevo Operador"
                                name={
                                  <button type="button" className="btn btn-success btn-sm">
                                    <Icon name="user-plus" /> Nuevo Operador
                                  </button>
                                }
                                formulario={require("../Operadores/OperadoresForm").default}
                                datosForm={{
                                  accion: "nuevo",
                                  elementos: null,
                                  getfuntion: Crud_Catalogos,
                                  stor: {},
                                  idTransportista: this.props.data.idTransportista?.id,
                                  multiPlataforma: true,
                                  onOperadorGuardado: () => this.recargarOperadores(),
                                }}
                              />
                            ) : (
                              this.state.operadorActualObj ? (
                                <ModalLay
                                  tamanio="80%"
                                  title="Editar Operador"
                                  name={
                                    <button type="button" className="btn btn-primary btn-sm">
                                      <Icon name="edit" /> Editar Operador
                                    </button>
                                  }
                                  formulario={require("../Operadores/OperadoresForm").default}
                                  datosForm={{
                                    accion: "editar",
                                    elementos: this.state.operadorOpcion
                                      ? this.state.operadorOpcion.value
                                      : this.state.operadorActualObj,
                                    getfuntion: Crud_Catalogos,
                                    stor: {},
                                    idTransportista: this.props.data.idTransportista?.id,
                                    onOperadorGuardado: (op) => this.recargarOperadores(op),
                                  }}
                                />
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={() => NotificationManager.warning(
                                    `El operador "${this.state.oldOperadorNombre || this.state.inputValue}" no existe en el catálogo de operadores.`,
                                    "Operador no encontrado",
                                    5000
                                  )}
                                >
                                  <Icon name="edit" /> Editar Operador
                                </button>
                              )
                            )}
                          </div>
                        )}
                      </div>
                   
                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="user" className="field-icon" />
                            Operador
                          </label>
                          <div className="field-content">
                            {!this.props.readonly ?  
                              <div>
                                <Select  components={{Input}} 
                                         onInputChange={this.onInputChange} 
                                         isClearable={true} 
                                         inputValue={this.state.inputValue}
                                         controlShouldRenderValue={false}  
                                         className="modern-select" 
                                         name="nombreOperador" 
                                         value={this.state.operadorOpcion == null ? this.state.inputValue : this.state.operadorOpcion} 
                                         onChange={(e,a)=>{ this.handleChange(e)}} 
                                         options={this.state.operadoresOpciones}
                                         menuPortalTarget={document.body}
                                         styles={{
                                           menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                           menuList: (base) => ({ ...base, maxHeight: 200 })
                                         }} />
                                <input
                                    tabIndex={0}
                                    autoComplete="off"
                                    style={{ opacity: 0, height: 0 }}
                                    value={this.state.inputValue}
                                    required={this.state.requiredOperador}
                                  /> 
                              </div>
                             : <span className="readonly-value">{this.state.inputValue}</span>
                            }
                          </div>
                        </div>
                        
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="phone" className="field-icon" />
                            Contacto
                          </label>
                          <div className="field-content">
                            <Form.Input className="modern-input" readOnly={true}  name="contacto" value={this.state.contacto == null ? this.state.operadorOpcion?.value.medioComunicacion : this.state.contacto} onChange={(e,a)=>{this.setState({contacto:e.value}) }} />
                          </div>
                        </div>
                      </div>
                
                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="calendar" className="field-icon" />
                            Vigencia
                          </label>
                          <div className="field-content">
                            <Form.Input type="date" className="modern-input" name="vigencia" value={this.state.vigencia} readOnly={true} onChange={(e,a)=>{this.setState({vigencia:e.target.value}) }} />
                          </div>
                        </div>

                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="credit-card" className="field-icon" />
                            Tipo de Licencia
                          </label>
                          <div className="field-content">
                            <Form.Input className="modern-input" name="tipo_licencia" readOnly={true} value={this.state.licencia == null && this.state.licencia == "" ? this.state.operadorOpcion?.value.licenciaTipo : this.state.licencia} onChange={(e,a)=>{this.setState({licencia:e.value}) }} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="section-card">
                      <div className="section-header">
                        <Icon name="truck" className="section-icon" />
                        <h4 className="section-title">INFORMACIÓN DEL TRACTO</h4>
                        {!this.props.readonly && (
                          <div style={{ marginLeft: '16px' }}>
                            {!(this.state.tractorPlaca || this.state.economicot) ? (
                              <ModalLay
                                tamanio="60%"
                                title="Nuevo Tracto"
                                name={
                                  <button type="button" className="btn btn-success btn-sm">
                                    <Icon name="plus" /> Nuevo Tracto
                                  </button>
                                }
                                formulario={TractosForm}
                                datosForm={{
                                  accion: "nuevo",
                                  elementos: null,
                                  idTransportista: this.props.data.idTransportista?.id,
                                  multiPlataforma: true,
                                  onSave: (tractoNuevo) => {
                                    // Construir la opción directamente con los datos del tracto creado
                                    const nuevoTractoObj = {
                                      id: tractoNuevo.id,
                                      placa: tractoNuevo.placa,
                                      economico: tractoNuevo.economico,
                                      color: tractoNuevo.color,
                                      modelo: tractoNuevo.modelo,
                                      idUnidadMarca: tractoNuevo.idUnidadMarca,
                                      estatus: true,
                                    };
                                    const nuevoTractoOpcion = { value: nuevoTractoObj, label: tractoNuevo.placa || "Sin placa" };
                                    
                                    // Agregar al dropdown y auto-seleccionar
                                    const tractosActualizados = [...this.state.tractosOpciones, nuevoTractoOpcion];
                                    this.setState({ tractosOpciones: tractosActualizados });
                                    this.handleChangeTracto(nuevoTractoOpcion);
                                  },
                                }}
                              />
                            ) : this.state.tractoActualObj ? (
                              <ModalLay
                                tamanio="60%"
                                title="Editar Tracto"
                                name={
                                  <button type="button" className="btn btn-primary btn-sm">
                                    <Icon name="edit" /> Editar Tracto
                                  </button>
                                }
                                formulario={TractosForm}
                                datosForm={{
                                  accion: "editar",
                                  elementos: {
                                    id: this.state.tractoActualObj.id,
                                    placa: this.state.tractorPlaca,
                                    economico: this.state.economicot,
                                    idUnidadMarca: this.state.marca
                                      ? { id: this.state.marca.id, nombre: this.state.marca.label }
                                      : null,
                                    color: this.state.color ? this.state.color.value : "",
                                    modelo: this.state.modelo ? String(this.state.modelo.value) : "",
                                  },
                                  idTransportista: this.props.data.idTransportista?.id,
                                  onSave: (tractoActualizado) => {
                                    const colorSel = this.state.colorsOpciones.find(c => c.label.toLowerCase() === (tractoActualizado.color || "").toLowerCase()) || (tractoActualizado.color ? {label: tractoActualizado.color, value: tractoActualizado.color} : this.state.color);
                                    const marcaSel = this.state.marcaOpciones.find(m => m.id === tractoActualizado.idUnidadMarca?.id) || this.state.marca;
                                    const modeloSel = this.state.modeloOpciones.find(m => m.value === parseInt(tractoActualizado.modelo)) || this.state.modelo;
                                    this.setState({
                                      tractorPlaca: tractoActualizado.placa || this.state.tractorPlaca,
                                      economicot: tractoActualizado.economico || this.state.economicot,
                                      color: colorSel,
                                      marca: marcaSel,
                                      modelo: modeloSel,
                                    });
                                    // Registrar edición de tracto en bitácora
                                    let descEdicion = "Edición de Tracto: Placa " + (tractoActualizado.placa || "") + ", Color: " + (tractoActualizado.color || "") + ", Marca: " + (tractoActualizado.idUnidadMarca?.id ? marcaSel?.label : "") + ", Modelo: " + (tractoActualizado.modelo || "");
                                    Crud_Catalogos("usuariosLog", "", "post", "", {
                                      idBitacoraMonitoreo: 18,
                                      idUsuario: this.props.usuario.id,
                                      idMovimiento: this.props.data.id,
                                      accionFecha: this.myFormato(new Date()),
                                      descripcion: descEdicion,
                                      idPlataformaTipo: 1,
                                    });
                                  },
                                }}
                              />
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => NotificationManager.warning(
                                  `El tracto "${this.state.tractorPlaca || this.state.economicot}" no existe en el catálogo de unidades.`,
                                  "Tracto no encontrado",
                                  5000
                                )}
                              >
                                <Icon name="edit" /> Editar Tracto
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                      
                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="hash" className="field-icon" />
                            Placa Tractor
                          </label>
                          <div className="field-content">
                            {!this.props.readonly ?
                              <Select
                                isClearable={true}
                                className="modern-select"
                                name="placa_tractor"
                                placeholder="Seleccione un tracto..."
                                value={this.state.tractoOpcion}
                                onChange={this.handleChangeTracto}
                                options={this.state.tractosOpciones}
                                getOptionLabel={(o) => o.label || o.value?.placa || ""}
                                getOptionValue={(o) => o.value?.placa || o.label || ""}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                  menuList: (base) => ({ ...base, maxHeight: 200 })
                                }}
                              />
                              : <span className="readonly-value">{this.state.tractorPlaca}</span>
                            }
                            <input type="hidden" name="placa_tractor" value={this.state.tractorPlaca || ""} />
                          </div>
                        </div>

                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="tag" className="field-icon" />
                            Económico Tractor
                          </label>
                          <div className="field-content">
                            <Form.Input className="modern-input" name="economicot" readOnly={true} value={this.state.economicot} onChange={(e,a)=>{this.setState({economicot:e.value})}} />
                          </div>
                        </div>
                      </div>

                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="award" className="field-icon" />
                            Marca
                          </label>
                          <div className="field-content">
                            <this.SelectMarca className="modern-select" name="marca" value={this.state.marca} isDisabled={true} onChange={(e,a)=>{this.setState({marca:e})}} options={this.state.marcaOpciones} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }} />
                          </div>
                        </div>

                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="circle" className="field-icon" />
                            Color
                          </label>
                          <div className="field-content">
                            <this.SelectColor className="modern-select" name="color" value={this.state.color} isDisabled={true} onChange={(e,a)=>{ this.setState({color:e})}} options={this.state.colorsOpciones} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }} />
                          </div>
                        </div>
                      </div>
                      
                      <div className="form-field full-width">
                        <label className="field-label">
                          <Icon name="calendar" className="field-icon" />
                          Modelo
                        </label>
                        <div className="field-content">
                          <this.SelectModelo className="modern-select" name="modelo" value={this.state.modelo} isDisabled={true} onChange={(e,a)=>{this.setState({modelo:e})}} options={this.state.modeloOpciones} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }} />
                        </div>
                      </div>
                    </div>
                      
                    <div className="section-card">
                      <div className="section-header">
                        <Icon name="package" className="section-icon" />
                        <h4 className="section-title">INFORMACIÓN DEL REMOLQUE</h4>
                        {!this.props.readonly && (
                          <div style={{ marginLeft: '16px' }}>
                            {!(this.state.remolquePlaca || this.state.economicor) ? (
                              <ModalLay
                                tamanio="50%"
                                title="Nuevo Remolque"
                                name={
                                  <button type="button" className="btn btn-success btn-sm">
                                    <Icon name="plus" /> Nuevo Remolque
                                  </button>
                                }
                                formulario={RemolquesForm}
                                datosForm={{
                                  accion: "nuevo",
                                  elementos: null,
                                  idTransportista: this.props.data.idTransportista?.id,
                                  multiPlataforma: true,
                                  onSave: (remolqueNuevo) => {
                                    // Construir la opción directamente con los datos del remolque creado
                                    const nuevoRemolqueObj = {
                                      idRemolque: remolqueNuevo.idRemolque,
                                      placa: remolqueNuevo.placa,
                                      economico: remolqueNuevo.economico,
                                      remolquesTipos: remolqueNuevo.remolquesTipos,
                                    };
                                    const nuevoRemOpcion = { value: nuevoRemolqueObj, label: remolqueNuevo.placa || "Sin placa" };
                                    
                                    // Agregar al dropdown y auto-seleccionar
                                    const remolquesActualizados = [...this.state.remolquesDropdownOpciones, nuevoRemOpcion];
                                    this.setState({ remolquesDropdownOpciones: remolquesActualizados });
                                    this.handleChangeRemolque(nuevoRemOpcion);
                                  },
                                }}
                              />
                            ) : this.state.remolqueActualObj ? (
                              <ModalLay
                                tamanio="50%"
                                title="Editar Remolque"
                                name={
                                  <button type="button" className="btn btn-primary btn-sm">
                                    <Icon name="edit" /> Editar Remolque
                                  </button>
                                }
                                formulario={RemolquesForm}
                                datosForm={{
                                  accion: "editar",
                                  elementos: {
                                    idRemolque: this.state.remolqueActualObj.idRemolque,
                                    placa: this.state.remolquePlaca,
                                    economico: this.state.economicor,
                                    remolquesTipos: this.state.remolque
                                      ? { idRemolque: this.state.remolque.value, nombre: this.state.remolque.label }
                                      : null,
                                  },
                                  idTransportista: this.props.data.idTransportista?.id,
                                  onSave: (remolqueActualizado) => {
                                    const tipoSel = this.state.remolquesOpciones.find(r => r.value === remolqueActualizado.remolquesTipos?.idRemolque) || this.state.remolque;
                                    this.setState({
                                      remolquePlaca: remolqueActualizado.placa || this.state.remolquePlaca,
                                      economicor: remolqueActualizado.economico || this.state.economicor,
                                      remolque: tipoSel,
                                    });
                                    // Registrar edición de remolque en bitácora
                                    let descRemolque = "Edición de Remolque: Placa " + (remolqueActualizado.placa || "") + ", Económico: " + (remolqueActualizado.economico || "") + ", Tipo: " + (tipoSel?.label || "");
                                    Crud_Catalogos("usuariosLog", "", "post", "", {
                                      idBitacoraMonitoreo: 18,
                                      idUsuario: this.props.usuario.id,
                                      idMovimiento: this.props.data.id,
                                      accionFecha: this.myFormato(new Date()),
                                      descripcion: descRemolque,
                                      idPlataformaTipo: 1,
                                    });
                                  },
                                }}
                              />
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() => NotificationManager.warning(
                                  `El remolque "${this.state.remolquePlaca || this.state.economicor}" no existe en el catálogo de remolques.`,
                                  "Remolque no encontrado",
                                  5000
                                )}
                              >
                                <Icon name="edit" /> Editar Remolque
                              </button>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="package" className="field-icon" />
                            Tipo de Remolques
                          </label>
                          <div className="field-content">
                            <this.SelectRemolques 
                              className="modern-select" 
                              name="idRemolque" 
                              required 
                              value={this.state.remolque} 
                              isDisabled={true}
                              onChange={(e)=>{ 
                                this.setState({remolque:e}); 
                                this.setState({newTipoRemolque:e ? e.label : ""}); 
                                e && e.value != null ? this.setState({required:false}): this.setState({required:true}) 
                              }} 
                              options={this.state.remolquesOpciones} 
                              menuPortalTarget={document.body} 
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }} 
                            />
                            <input
                                tabIndex={-4}
                                autoComplete="off"
                                style={{ opacity: 0, height: 0 }}
                                value={this.state.remolque ? this.state.remolque.value : ""}
                                required={this.state.required}
                              />
                          </div>
                        </div>

                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="tag" className="field-icon" />
                            Económico Remolque
                          </label>
                          <div className="field-content">
                            <Form.Input className="modern-input" name="economicor" required value={this.state.economicor} readOnly={true} onChange={(e,a)=>{this.setState({economicor:e.value})}} />
                          </div>
                        </div>
                      </div>

                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="hash" className="field-icon" />
                            Placa Remolque
                          </label>
                          <div className="field-content">
                            {!this.props.readonly ?
                              <Select
                                isClearable={true}
                                className="modern-select"
                                name="placa_remolque"
                                placeholder="Seleccione un remolque..."
                                value={this.state.remolqueDropdownOpcion}
                                onChange={this.handleChangeRemolque}
                                options={this.state.remolquesDropdownOpciones}
                                getOptionLabel={(o) => o.label || o.value?.placa || ""}
                                getOptionValue={(o) => o.value?.placa || o.label || ""}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                  menuList: (base) => ({ ...base, maxHeight: 200 })
                                }}
                              />
                              : <span className="readonly-value">{this.state.remolquePlaca}</span>
                            }
                            <input type="hidden" name="placa_remolque" value={this.state.remolquePlaca || ""} />
                          </div>
                        </div>

                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="map-pin" className="field-icon" />
                            GPS Fijo
                          </label>
                          <div className="field-content">
                            <span className="readonly-value">{this.state.remolqueGpsFijo || "-"}</span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="form-switch">
                        <Form.Switch
                          type="Checkbox"
                          label={this.state.esFull ? "Movimiento en full" : "Colocar en full"}
                          checked={this.state.esFull}
                          disabled={this.state.fullBloqueado}
                          onChange={(e)=> { if(!this.state.fullBloqueado){ this.setState({esFull:e.target.checked}); } }}
                            />
                        {this.state.fullBloqueado && (
                          <small className="text-muted d-block mt-1">
                            Este movimiento ya está enfullado. El full no puede modificarse ni quitarse.
                          </small>
                        )}

                        {this.state.esFull  ? (

                          <div>
                          <div className="section-header">
                            <Icon name="package" className="section-icon" />
                            <h4 className="section-title">MOVIMIENTO FULL</h4>
                            {!this.state.remolque2ActualObj && !this.state.remolqueFullSeleccionado ? (
                              <div style={{ marginLeft: '16px' }}>
                                <ModalLay
                                  tamanio="50%"
                                  title="Nuevo Remolque Full"
                                  name={
                                    <button type="button" className="btn btn-success btn-sm">
                                      <Icon name="plus" /> Nuevo Remolque Full
                                    </button>
                                  }
                                  formulario={RemolquesForm}
                                  datosForm={{
                                    accion: "nuevo",
                                    elementos: null,
                                    idTransportista: this.props.data.idTransportista?.id,
                                    multiPlataforma: true,
                                    onSave: (remolqueNuevo) => {
                                      // Construir la opción directamente con los datos del remolque creado
                                      const nuevoRemFullObj = {
                                        idRemolque: remolqueNuevo.idRemolque,
                                        placa: remolqueNuevo.placa,
                                        economico: remolqueNuevo.economico,
                                        remolquesTipos: remolqueNuevo.remolquesTipos,
                                      };
                                      const nuevoRemFullOpcion = { value: remolqueNuevo.idRemolque, label: remolqueNuevo.placa, data: nuevoRemFullObj };
                                      const tipoRemFull = remolqueNuevo.remolquesTipos
                                        ? { value: remolqueNuevo.remolquesTipos.idRemolque, label: remolqueNuevo.remolquesTipos.nombre || "" }
                                        : null;
                                      
                                      // Agregar al dropdown de remolques full y auto-seleccionar
                                      const remolquesFullActualizados = [...this.state.remolquesFullOpciones, nuevoRemFullOpcion];
                                      this.setState({
                                        remolquesFullOpciones: remolquesFullActualizados,
                                        remolqueFullSeleccionado: nuevoRemFullOpcion,
                                        remolque2ActualObj: nuevoRemFullObj,
                                        remolqueFullTipo: tipoRemFull,
                                        remolqueFullGpsFijo: null,
                                        remolqueFullGpsFijoId: null,
                                        movimientosPatiosFull: {
                                          ...this.state.movimientosPatiosFull,
                                          remolquePlaca: remolqueNuevo.placa,
                                          economicor: remolqueNuevo.economico || "",
                                        }
                                      });
                                    },
                                  }}
                                />
                              </div>
                            ) : this.state.remolque2ActualObj ? (
                              <div style={{ marginLeft: '16px' }}>
                                <ModalLay
                                  tamanio="50%"
                                  title="Editar Remolque Full"
                                  name={
                                    <button type="button" className="btn btn-primary btn-sm">
                                      <Icon name="edit" /> Editar Remolque Full
                                    </button>
                                  }
                                  formulario={RemolquesForm}
                                  datosForm={{
                                    accion: "editar",
                                    elementos: {
                                      idRemolque: this.state.remolque2ActualObj.idRemolque,
                                      placa: this.state.movimientosPatiosFull.remolquePlaca,
                                      economico: this.state.movimientosPatiosFull.economicor,
                                      remolquesTipos: this.state.remolqueFullTipo
                                        ? { idRemolque: this.state.remolqueFullTipo.value, nombre: this.state.remolqueFullTipo.label }
                                        : null,
                                    },
                                    idTransportista: this.props.data.idTransportista?.id,
                                    onSave: (remolqueActualizado) => {
                                      const tipoSel = this.state.remolquesOpciones.find(r => r.value === remolqueActualizado.remolquesTipos?.idRemolque) || this.state.remolqueFullTipo;
                                      this.setState(prevState => ({
                                        movimientosPatiosFull: {
                                          ...prevState.movimientosPatiosFull,
                                          remolquePlaca: remolqueActualizado.placa || prevState.movimientosPatiosFull.remolquePlaca,
                                          economicor: remolqueActualizado.economico || prevState.movimientosPatiosFull.economicor,
                                        },
                                        remolqueFullTipo: tipoSel,
                                      }));
                                      // Registrar edición de remolque full en bitácora
                                      let descRemFull = "Edición de Remolque Full: Placa " + (remolqueActualizado.placa || "") + ", Económico: " + (remolqueActualizado.economico || "") + ", Tipo: " + (tipoSel?.label || "");
                                      Crud_Catalogos("usuariosLog", "", "post", "", {
                                        idBitacoraMonitoreo: 18,
                                        idUsuario: this.props.usuario.id,
                                        idMovimiento: this.props.data.id,
                                        accionFecha: this.myFormato(new Date()),
                                        descripcion: descRemFull,
                                        idPlataformaTipo: 1,
                                      });
                                    },
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                            
                              <div class="row">
                                <div className="col col-12 col-sm-12 col-md-4">
                                  <Form.Group label="WO- BOOKING - SERVICE ORDER -CONTENEDOR FULL (requerido)">
                                    <this.SelectMovFull 
                                      sClearable={false} 
                              
                                      required={this.state.esFull}
                                       className="select-movfull" 
                                       name="movfull" 
                                      value={this.state.movimientoSecundario}
                                       options={this.state.movimientosSinGps}
                                       menuIsOpen={this.state.fullBloqueado ? false : undefined}
                                      onChange={(e)=>{
                                        if(this.state.fullBloqueado){ return; }
                                        this.setState({movimientoSecundario:e});

                                        this.setState(prevState => ({
                                          movimientosPatiosFull: {
                                            ...prevState.movimientosPatiosFull,
                                            esFull: this.props.data.id,
                                            id:e.data.movimientosPatios.length > 0 ? e.data.movimientosPatios[0].id : null,
                                            idMovimiento: Number(e.value),
                                            idUsuario: {"id":this.props.usuario.id},
                                          }
                                        }))
                                        this.setState(prevState => ({
                                          movimientosPatios: {
                                            ...prevState.movimientosPatios,
                                            esFull: e.value
                                          }
                                        }));
                                      }}
                                     
                                      isDisabled={this.state.fullBloqueado || Boolean(this.state.movimientosPatios?.esFull && this.state.movimientoSecundario)}
                                    />
                                    {this.state.esFull && (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0) && (
                                      <span style={{ color: 'red', fontSize: '12px' }}>*Este campo es obligatorio</span>
                                    )}
                                  </Form.Group>
                                </div>
                                <div className="col col-12 col-sm-12 col-md-4 ">
                                  <Form.Group label="Placa Remolque Full">
                                    <Select
                                      name="placaRemolqueF"
                                      placeholder="Seleccione remolque..."
                                      value={this.state.remolqueFullSeleccionado}
                                      options={this.state.remolquesFullOpciones.filter(r => 
                                        // Excluir el remolque del movimiento principal
                                        r.label !== this.state.remolquePlaca
                                      )}
                                      onChange={(e) => {
                                        if (e && e.data) {
                                          const remData = e.data;
                                          const tipoRemFull = remData.remolquesTipos
                                            ? { value: remData.remolquesTipos.idRemolque, label: remData.remolquesTipos.nombre }
                                            : null;
                                          this.setState({
                                            remolqueFullSeleccionado: e,
                                            remolque2ActualObj: remData,
                                            remolqueFullTipo: tipoRemFull,
                                            remolqueFullGpsFijo: null,
                                            remolqueFullGpsFijoId: null,
                                            movimientosPatiosFull: {
                                              ...this.state.movimientosPatiosFull,
                                              remolquePlaca: remData.placa,
                                              economicor: remData.economico || "",
                                            }
                                          });
                                          // Consultar GPS fijo vinculado al remolque full (por placa)
                                          if (remData.placa) {
                                            Crud_Catalogos("remolquesGpsFijos/placa/" + encodeURIComponent(remData.placa) + "/activo", "", "get", "", [], "", "", "", [])
                                              .then((vinc) => {
                                                this.setState({
                                                  remolqueFullGpsFijo: (vinc && vinc.gps) ? vinc.gps.nombre : null,
                                                  remolqueFullGpsFijoId: (vinc && vinc.gps) ? vinc.gps.id : null,
                                                });
                                              })
                                              .catch(() => this.setState({ remolqueFullGpsFijo: null, remolqueFullGpsFijoId: null }));
                                          }
                                        } else {
                                          this.setState({
                                            remolqueFullSeleccionado: null,
                                            remolque2ActualObj: null,
                                            remolqueFullTipo: null,
                                            remolqueFullGpsFijo: null,
                                            remolqueFullGpsFijoId: null,
                                            movimientosPatiosFull: {
                                              ...this.state.movimientosPatiosFull,
                                              remolquePlaca: "",
                                              economicor: "",
                                            }
                                          });
                                        }
                                      }}
                                      isClearable={true}
                                      isDisabled={this.props.readonly}
                                      menuPortalTarget={document.body}
                                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                    />
                                    <input
                                      tabIndex={-4}
                                      autoComplete="off"
                                      style={{ opacity: 0, height: 0 }}
                                      value={this.state.remolqueFullSeleccionado ? this.state.remolqueFullSeleccionado.value : ""}
                                      required={this.state.esFull}
                                      onChange={() => {}}
                                    />
                                  </Form.Group>
                                </div>
                                <div className="col col-12 col-sm-12 col-md-4 ">
                                  <Form.Group label="Economico (Remolque)">
                                    
                                    <Form.Input
                                      name="economicorF"
                                      type="text"
                                      readOnly={true}
                                      value={this.state.movimientosPatiosFull.economicor}
                                    />{" "}
                                  </Form.Group>
                                </div>
                                <div className="col col-12 col-sm-12 col-md-4 ">
                                  <Form.Group label="Tipo de Remolque">
                                    <Form.Input
                                      name="tipoRemolqueF"
                                      type="text"
                                      readOnly={true}
                                      value={this.state.remolqueFullTipo ? this.state.remolqueFullTipo.label : ""}
                                    />{" "}
                                  </Form.Group>
                                </div>
                                <div className="col col-12 col-sm-12 col-md-4 ">
                                  <Form.Group label="GPS Fijo">
                                    <Form.Input
                                      name="gpsFijoF"
                                      type="text"
                                      readOnly={true}
                                      value={this.state.remolqueFullGpsFijo || "-"}
                                    />{" "}
                                  </Form.Group>
                                </div>
                                <div className="col col-12 col-sm-12 col-md-4 ">
                                  <Form.Group label="Observaciones">
                                    {" "}
                                    <Form.Textarea
                                    required
                                      name="observacionesF"
                                      onChange={(e)=>   this.setState(prevState => ({
                                        movimientosPatiosFull: {
                                          ...prevState.movimientosPatiosFull,  // Mantén todos los campos existentes
                                          observaciones: e.target.value// Sobrescribe solo el email
                                        }
                                      }))}
                                    >{this.state.movimientosPatiosFull.observaciones}</Form.Textarea>{" "}
                                  </Form.Group>
                                </div>
                              </div>

                      
                            
                            
                              </div>   
                        
                        ) : null}
                      </div>
                    </div>
                    

                    <div className="section-card">
                      <div className="section-header">
                        <Icon name="map-pin" className="section-icon" />
                        <h4 className="section-title">INFORMACIÓN DEL PATIO</h4>
                      </div>
                      
                      <div className="form-grid">
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="map-pin" className="field-icon" />
                            Patio
                          </label>
                          <div className="field-content">
                            <div style={{display:"flex", alignItems:"center", gap:"8px"}}>
                              <div style={{flex:1, minWidth:0}}>
                              <this.SelectPatios  
                                       onInputChange={this.onInputChange} 
                                       isClearable={false} 
                                      isDisabled={this.props.readOnly || this.props.readonly}
                                      required
                                       className="modern-select patio-select" 
                                       name="patios" 
                                       value={this.state.colocacionPatioOpcion} 
                                       onChange={this.changePatio} 
                                       options={this.state.colocacionPatios}
                                       menuPortalTarget={document.body}
                                       styles={{
                                         menuPortal: (base) => ({ ...base, zIndex: 99999 })
                                       }} />
                              </div>
                              
                              {!this.props.readonly && (
                                <div className="patio-add-btn" style={{flexShrink:0}}>
                                <ModalLay
                                  tamanio="50%"
                                  title={"Nuevo"}
                                  name={
                                    <button type="button" className="add-btn" title="Nuevo patio" style={{margin:0}}>
                                      <Icon name="plus" />
                                    </button>
                                  }
                                  hiddenModal={this.state.hiddenModals}
                                  Fclose={this.hiddenmodal}
                                  formulario={PatiosForm }
                                  datosForm={{
                                    accion: "nuevo",
                                    data: this.props.data,
                                    getfuntion: Crud_Catalogos,
                                    stor: this.props.stor,
                                    updateData:this.updateData
                                  }}
                                />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form-field">
                          <label className="field-label">
                            <Icon name="check-square" className="field-icon" />
                            Estatus
                          </label>
                          <div className="field-content" style={{display:"flex", alignItems:"center", height:"44px"}}>
                            <Form.Switch
                              name="enPatio"
                              type="Checkbox"
                              label={"Unidad en Patio"}
                              checked={this.state.movimientosPatios?.enPatio}
                              onChange={(e)=> this.setState({enPatio:e.target.checked})}
                            />
                          </div>
                        </div>
                      </div>
                      
                      <div className="map-container">
                        <Map
                         coordenadas={this.state.coordenadas}
                         tamanio={{width:"auto",height:"200px"}}
                        >
                        </Map>
                      </div>
                    </div>
                     {!this.props.readonly ? 
                      <div className="form-actions">
                        <button type="submit" className="submit-btn modern-register-btn"
                          disabled={this.state.esFull && (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0)}
                          style={this.state.esFull && (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                        >
                          <Icon name="save" className="btn-icon" />
                          Registrar
                        </button>
                      </div>
                      :null}
                    </Form>
                  </div>
                  :
                  <List.Group>
                    <List.GroupItem action icon="truck"> Transportista:   <strong> { this.props.data.idTransportista? this.props.data.idTransportista.nombre:""} </strong> </List.GroupItem>
                    <Form onSubmit={this.handleSubmit} >
                    <ListGroupItem className="titleForm-Patios">INFORMACION DEL OPERADOR</ListGroupItem>


                    <div className="row">

                      <div className="col-md-6">

                      <List.GroupItem action icon="user"   className="operador-flex" >Operador:
                          <Select  components={{Input}} 
                                   onInputChange={this.onInputChange} 
                                   isClearable={true} 
                                   inputValue={this.state.inputValue}
                                   controlShouldRenderValue={false}  
                                   className="select-operador" 
                                   name="nombreOperador" 
                                   value={this.state.operadorOpcion} 
                                   onChange={(e,a)=>{ this.handleChange(e)}} 
                                   options={this.state.operadoresOpciones} />
                      <input
                          tabIndex={-4}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0 }}
                          value={this.state.inputValue}
                          
                          required={this.state.requiredOperador}
                        />    

                      
                  
                      </List.GroupItem>  

                      </div>


                      <div className="col-md-6">
                      <List.GroupItem action icon="phone"  className="operador-flex"> Contacto:       <Form.Input className="select-operador"  name="contacto" value={this.state.operadorOpcion != null ? this.state.operadorOpcion.value.medioComunicacion : this.state.contacto} onChange={(e,a)=>{this.setState({contacto:e.value}) }} >  </Form.Input> 
                      
                   
                      </List.GroupItem>
                      </div>

                    </div>



                    <div className="row">
                      <div className="col-md-6">
                      <List.GroupItem action icon="underline" className="operador-flex"> Vigencia:         <Form.Input type="date" className="select-operador"  name="vigencia" defaultValue={"test"}   value={this.state.operadorOpcion != null ? this.state.operadorOpcion.value.licenciaVigencia : this.state.vigencia} onChange={(e,a)=>{this.setState({vigencia:e.value}) }} > 
                        </Form.Input> 
                      
                      </List.GroupItem>
                      </div>

                      <div className="col-md-6">
                      <List.GroupItem action icon="underline" className="operador-flex"> Tipo de Licencias: <Form.Input className="select-operador"  name="tipo_licencia" value={this.state.operadorOpcion || this.state.operadorOpcion.value.licencia  ? this.state.operadorOpcion.value.licenciaTipo : this.state.licencia} onChange={(e,a)=>{this.setState({licencia:e.value}) }} > </Form.Input> 

                        
                      </List.GroupItem>
                      </div>
                    </div>

                    <ListGroupItem className="titleForm-Patios">INFORMACION DEL TRACTO</ListGroupItem>


                    <div className="row">
                      <div className="col-md-6">
                      <List.GroupItem action icon="pocket" className="operador-flex"> Marca:          <this.SelectMarca className="select-operador" name="marca"  options={this.state.marcaOpciones}  /> </List.GroupItem>


                      </div>

                      <div className="col-md-6">
                      <List.GroupItem action icon="truck"     className="operador-flex"> Eco tracto:   <Form.Input className="select-operador" name="economicot" >  </Form.Input> </List.GroupItem> 

                      </div>
                    </div>
                           
                    


                    <div className="row">
                      <div className="col-md-6">
                      <List.GroupItem action icon="circle" className="operador-flex"> Color:          <this.SelectColor className="select-operador" name="color"  options={this.state.colorsOpciones}  />

                        </List.GroupItem>
                      </div>

                      <div className="col-md-6">
                      <List.GroupItem action icon="underline" className="operador-flex"> Modelo:      <this.SelectModelo className="select-operador" name="modelo"   options={this.state.modeloOpciones} /> </List.GroupItem>

                      </div>
                    </div>

                    <List.GroupItem action icon="truck"  className="operador-flex"> Placa tracto:  <Form.Input className="select-operador" name="placa_tractor" ></Form.Input> </List.GroupItem>                  

                    <ListGroupItem className="titleForm-Patios">INFORMACION DEL REMOLQUE</ListGroupItem>


                    <div className="row">
                      <div className="col-md-6">
                      <List.GroupItem action icon="user"      className="operador-flex"> Selecciona tipo de remolque:<this.SelectRemolques 
                        className="select-operador" 
                        name="idRemolque" 
                        value={this.state.remolque} 
                        onChange={(e)=>{ 
                          this.setState({remolque:e}); 
                          this.setState({newTipoRemolque: e ? e.label : ""}); 
                          e && e.value != null ? this.setState({required:false}): this.setState({required:true})  
                        }} 
                        options={this.state.remolquesOpciones} 
                        required 
                      />
                      <input
                          tabIndex={-4}
                          autoComplete="off"
                          style={{ opacity: 0, height: 0 }}
                          value={this.state.remolque ? this.state.remolque.value : ""}
                          required={this.state.required}
                        />  
                      </List.GroupItem> 
                      </div>

                      <div className="col-md-6">

                      
                      <List.GroupItem action icon="truck"     className="operador-flex"> Eco Remolque:   <Form.Input className="select-operador" name="economicor" required>  </Form.Input> 
                      </List.GroupItem>
                     
                      </div>
                    </div>
                       
                    


                    <div className="row">
                  

                      <div className="col-md-12">
                      <List.GroupItem action icon="truck"     className="operador-flex"> Placa Remolque:   <Form.Input className="select-operador" name="placa_remolque" required>  </Form.Input> </List.GroupItem>

                      </div>
                    </div>
                       
                     
 
                    <ListGroupItem className="titleForm-Patios"> INFORMACION DEL PATIO</ListGroupItem>


                  <div className="row">
                    <div className="col-md-12">
                    <List.GroupItem action icon="user" className="operador-flex" >Patio:
                                            <div style={{display:"flex", alignItems:"center", flex:1}}>
                                            <this.SelectPatios  
                                                    onInputChange={this.onInputChange} 
                                                    isClearable={false} 
                                                    className="select-operador" 
                                                    name="patios" 
                                                    required
                                                    value={this.state.colocacionPatioOpcion} 
                                                    onChange={this.changePatio} 
                                                    options={this.state.colocacionPatios} />
                                            <ModalLay
                                                    tamanio="80%"
                                                    title={"Nuevo"}
                                                    name={
                                                      <span
                                                        className="fa fa-plus ml-2"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title={"Nuevo patio(Antes de crear valida que no exista)"}
                                                        style={{cursor:"pointer", fontSize:"18px"}}
                                                      ></span>
                                                    }
                                                    hiddenModal={this.state.hiddenModals}
                                                    Fclose={this.hiddenmodal}
                                                    formulario={PatiosForm}
                                                    datosForm={{
                                                      accion: "nuevo",
                                                      data: this.props.data,
                                                      getfuntion: Crud_Catalogos,
                                                      stor: this.props.stor,
                                                      updateData: this.updateData
                                                    }}
                                                  />
                                            </div>
                                        </List.GroupItem>
                                          {
                                  <Form.Switch
                                    type="Checkbox"
                                    name="enPatio"
                                    label={"Unidad en Patio"}
                                    checked={this.state.movimientosPatios?.enPatio != null ? true : false}
                                    onChange={(e)=> this.setState({enPatio:e.target.checked})}
                                      />
                                      }
                    </div>
                  </div>

                      <ListGroupItem>
                      <Map
                       coordenadas={this.state.coordenadas}
                       tamanio={{width:"auto",height:"200px"}}
                      >
                      </Map>

                    </ListGroupItem>
                      
                    
                      <div className="float-right">
                                   
                                    <span class="badge">
                                        <Button  type="submit" size="sm" color="primary"
                                          disabled={this.state.esFull && (!this.state.movimientoSecundario || !this.state.movimientoSecundario.value || this.state.movimientoSecundario.value === 0)}
                                        >
                                        <span class="badge"><Icon  name="save" />Registrar</span>
                                        </Button>
                                   </span>

                      </div>
                    </Form>
                  </List.Group>
      )
}}

export default OperadoresNavieros;